<template>
  
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span v-if="type=='henshu'" class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="setting()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
      <span v-else class="sp-title" style="color:#FFF;background: #FF8400;">
        <slot>タイトル</slot>
        <input type="text" class="form-control"  value="未登録" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" style="cursor:pointer" v-on:click="mypage" v-if="type=='henshu'">マイページ</li>
        <li class="breadcrumb-item" style="cursor:pointer" v-on:click="setting" v-if="type=='henshu'">設定</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
        </ol>
    </nav>

    <div id="manual_area" style="margin-bottom:10px">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />プロフィールのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>
    </div>
      
    <br clear="all">
    <div v-if="mode=='confirm'">
    <!-- 確認モード -->
      <h3 style="text-align:left">登録内容を確認して、「{{ button_mongon }}」または「入力に戻る」ボタンをクリックしてください。</h3>
      <table class="vy-form-table">
      <!-- 氏名（姓） -->
      <template v-if="'username_sei' in schema_list">
        <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
              <label for="username_sei">氏名（姓）</label>
          </th>
          <td style="text-align: left;">
              {{ username_sei }}
          </td>
        </tr>
      </template>
      <!-- 氏名（名） -->
      <template v-if="'username_mei' in schema_list">
        <tr>
          <th>
              <label for="username_mei">氏名（名）</label>
          </th>
          <td style="text-align: left;">
              {{ username_mei }}
          </td>
        </tr>
      </template>
        <!-- 氏名かな（姓） -->
      <template v-if="'username_kana_sei' in schema_list">
        <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
          <tr>
            <th>
              <label for="username_kana_sei">氏名かな（姓）</label>
            </th>
            <td style="text-align: left;">
                {{ username_kana_sei }}
            </td>
          </tr>
      </template>
      <!-- 氏名かな（名） -->
      <template v-if="'username_kana_mei' in schema_list">
          <tr>
            <th>
              <label for="username_kana_mei">氏名かな（名）</label>
            </th>
            <td style="text-align: left;">
                {{ username_kana_mei }}
            </td>
          </tr>
      </template>
        <!-- 性別 -->
        <template v-if="'usersex' in schema_list">
          <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
              <label for="usersex">性別</label>
            </th>
            <td>
                {{ usersex }}
            </td>
          </tr>
        </template>
        <!-- 生年月日 -->
        <template v-if="'userbirth' in schema_list">
        <tr>
          <td colspan="3"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
            <label for="userbirth">生年月日</label>
          </th>
          <td style="text-align: left;">
            {{ DateYearSetting(userbirth)+'&emsp;('+getAge(userbirth)+' 歳)' }}
          </td>
        </tr>
      </template>
      
      <template v-if="getAge(userbirth) < pc_age">
      <tr >
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <tr >
        <th>
          <label for="parent_consent">保護者の同意
          </label>
        </th>
        <td style="text-align: left;">
          <span v-if="parent_consent == 'true'">同意済</span>
          <span v-else-if="parent_consent == 'false'">同意無</span>
        </td>
        </tr>
      </template>
        <!-- 郵便番号 -->
      <template v-if="'yubin' in schema_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
            <label for="yubin">郵便番号</label>
          </th>
          <td style="text-align: left;">
            {{ yubin }}
          </td>
        </tr>
      </template>
      <!-- 住所 -->
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
            <label for="address_kencd">住所（都道府県）</label>
          </th>
          <td style="text-align: left;">
            <template v-if="address_kencd != 0">
              {{ GlobalData.$Address_ken_list[address_kencd]}}
            </template>
          </td>
      </tr>
      <tr>
          <th>
            <label for="address_shi">住所（市町村）</label>
          </th>
          <td style="text-align: left;">
            {{ address_shi }}
          </td>
      </tr>
      
      <template v-if="'address_banchi' in schema_list">
      <tr>
          <th>
            <label for="address_banchi">住所（番地以降）</label>
          </th>
          <td style="text-align: left;">
            {{ address_banchi }}
          </td>
      </tr>
      </template>
        <!-- 電話番号1 -->

        <template v-if="'usertel1' in schema_list">
        <tr>
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>


      <tr>
        <th>
          <label v-if="'usertel2' in disp_list" for="usertel1">電話番号1</label>
          <label v-else for="usertel1">電話番号</label>
        </th>
        <td style="text-align: left;">
          {{ usertel1 }}
        </td>
        </tr>
      </template>
      
        <!-- 電話番号2 -->
      <template v-if="'usertel2' in schema_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
            <label for="usertel2">電話番号2</label>
          </th>
          <td style="text-align: left;">
          {{ usertel2 }}
          </td>
        </tr>
      </template>
      <!-- 保護者のお名前 -->
      <template v-if="getAge(userbirth) < pc_age">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr>
          <th>
            <label for="parent_name">保護者のお名前</label>
          </th>
          <td style="text-align: left;">
              {{parent_name}}
          </td>
        </tr>
        <!-- 保護者電話番号 -->
        <template v-if="'hogosyatel' in schema_list">
          <tr>
            <th>
              <label for="hogosyatel">保護者電話番号</label>
            </th>
            <td style="text-align: left;">
            {{ hogosyatel }}
            </td>
          </tr>
        </template>
      </template>
      <!-- 体験者区分 -->
      <template v-if="'shokugyo_kbn' in schema_list">
      <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <tr>
        <th>
            <label for="shokugyo_kbn">体験者区分</label>
        </th>
        <td style="text-align: left;">
          <template v-if="other_sanka == 1">
            <span v-if="shokugyo_kbn == '0'">学生</span>
            <span v-else-if="shokugyo_kbn == '1'">一般</span>
          </template>
          
          <template v-else>
            学生
          </template>
          
        </td>
      </tr>
      </template>
      <!-- 一般区分 -->
      <template v-if="shokugyo_kbn == '1'">
      <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <tr>
        <th>
            <label for="gakusei_kbn">一般区分</label>
        </th>
        <td style="text-align: left;">
          {{ ippan_select[ippan_kbn] }}
        </td>
      </tr>
      </template>
      <!-- 学生区分 -->
      <template v-if="shokugyo_kbn == '0'">
      <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <tr>
        <th>
            <label for="gakusei_kbn">学生区分</label>
        </th>
        <td style="text-align: left;">
          {{ gakusei_meisho_list[gakusei_kbn] }}
        </td>
      </tr>
      </template>
      <!-- 学校名 -->
      <template v-if="shokugyo_kbn == '0'">
      <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>
      <tr>
        <th>
            <label for="gakko_name">学校名</label>
        </th>
        <td style="text-align: left;">
          {{ gakko_name }}
        </td>
      </tr>
      </template>
      <!-- 学年 -->
      <template v-if="shokugyo_kbn == '0'">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
      <tr>
        <th>
            <label for="gakunen">学年</label>
        </th>
        <td>
          {{ gakunen }}
        </td>
      </tr>
      </template>
      <!-- 趣味・特技・資格 -->
      <template v-if="'shikaku' in schema_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        
        <tr>
          <th>
            <label for="shikaku">趣味・特技・資格</label>
          </th>
          <td style="text-align: left;white-space: pre-wrap;">
            {{ shikaku }}
          </td>
        </tr>
      </template>
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <!-- 初回登録年月日 -->
        <tr>
          <th>
            <label for="touroku_date">初回登録年月日</label>
          </th>
          <td style="text-align: left;">
            {{ DateYearSetting(touroku_date) }}
          </td>
        </tr>
      
      <template v-if="'katsudou_flg' in schema_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <!-- ボランティア活動経験 -->
        <tr>
          <th>
            <label for="katsudou_flg">ボランティア活動経験</label>
          </th>
          <td style="text-align: left;">

            <span v-if="katsudou_flg==true">
              あり
            </span>
            <span v-else-if="katsudou_flg==false">
              なし
            </span>
          </td>
        </tr>
      
        <!-- 活動内容 -->
        <tr v-if="katsudou_flg == true">
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr v-if="katsudou_flg == true">
          <th>
              <label for="katsudou_naiyo">ボランティア活動内容</label>
          </th>
          <td style="text-align: left;">
              {{ katsudou_naiyo }}             
          </td>
        </tr>
      </template>
      <template v-if="'smartphone' in schema_list">
        <tr>
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>

      <tr>
        
        <th>
          <label for="smartphone">当日のスマートフォンの使用</label>
        </th>
        <td style="text-align: left;">
            
            <span v-if="smartphone=='true'">
              可
            </span>
            <span v-else-if="smartphone=='false'">
              不可
            </span>
          </td>
        </tr>
      </template>

      <template v-if="'sending' in schema_list">
        <tr v-if="syurui == 2">
        <td colspan="2"><div class="vy-dotted"></div></td>
      </tr>

      <tr v-if="syurui == 2">
        
        <th>
          <label for="sending">アンケート・感想文の作成・送付方法</label>
        </th>
        <td style="text-align: left;">
          
          <span v-if="sending==1">
            紙
          </span>
          <span v-else-if="sending==2">
            メール
          </span>
        </td>
        </tr>
      </template>
      
        <!-- フリー項目（テキスト1） -->
      <template v-if="'free_text1' in disp_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        
        <tr>
          <th>
            <label for="user_free_text1">{{user_free_text1}}</label>
          </th>
          <td style="text-align: left;">
            {{ free_text1 }}
          </td>
        </tr>
      </template>
      
        <!-- フリー項目（テキスト2） -->
      <template v-if="'free_text2' in disp_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        
        <tr>
          <th>
            <label for="user_free_text2">{{user_free_text2}}</label>
          </th>
          <td style="text-align: left;">
            {{ free_text2 }}
          </td>
        </tr>
      </template>
      
        <!-- フリー項目（選択1） -->
      <template v-if="'free_choice1' in disp_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        
        <tr>
          <th>
            <label for="user_free_select1">{{user_free_select1}}</label>
          </th>
          <td style="text-align: left;">
            {{ user_free_choice1[free_choice1] }}
          </td>
        </tr>
      </template>
        <!-- フリー項目（選択2） -->
      <template v-if="'free_choice2' in disp_list">
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        
        <tr>
          <th>
            <label for="user_free_select2">{{user_free_select2}}</label>
          </th>
          <td style="text-align: left;">
            {{ user_free_choice2[free_choice2] }}
          </td>
        </tr>
      </template>
        <tr>
          <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
    </table>
  </div>


    <div v-if="mode=='end'">
      <!--ユーザー登録が閉め切られていた場合-->
      新規のユーザー登録は締め切りました。
      <br><br>
      <span style="cursor:pointer;width:200px"
        v-on:click="log_out()"><u>HOMEに戻る</u></span>  
    </div>

    <!-- ユーザ登録 -->
    <div v-else-if="mode=='toroku' || mode=='kakunin'">
      <span v-if="type!='henshu'">
        <div style="text-align:left">
          <p><span style="font-size:1.5rem">■</span>ユーザー情報（プロフィール）の登録
<!--     
            <div v-html="user_add_message"></div> 
-->
            <QuillEditor
              class="form-control"
              v-model:content="user_add_message"
              contentType="html"
              theme="snow"
              readOnly
              :toolbar="[]"
             style="height:auto;margin: 0px;padding: 0px;"
            />
          </p>
        </div>
        <!--
        <span class="sp_only" style="color:red;text-align:left">
                  <b>
                ※ 令和7年7月4日：アンドロイドご利用のお客様へ<br>
                一部ブラウザ（Yahooなど）でエラーが発生し、登録ができなくなることが報告されました。恐れ入りますが、ブラウザはChrome（推奨）をご使用下さい。 <br>
                （画面右下のマイページをタップして一旦ログアウトをお願いします。） 
                  </b>
        </span>-->
        <span class="sp_only" style="color: red;font-size:small;font-weight: bold;text-align:left">
          ※ご使用いただけるブラウザは、<br>iPhone：Safari / Android：Chorme<br>となります。ご了承ください。
        </span><br>

        <div v-if="isSP" style="text-align: center;font-size:medium;">
          <label style="display: flex;align-items: center;">
            <input type="checkbox" v-model="agreed"/>上記事項を確認した。
          </label>
        </div>
        <div v-else style="text-align: left;font-size:medium;">
          <label style="display: flex;align-items: center;">
            <input type="checkbox" v-model="agreed"/>上記事項を確認した。
          </label>
        </div>
        <br>
      </span>
      <h3 style="text-align:left" v-else>編集後、「確認」ボタンをクリックしてください。</h3>
      <Form @submit="Update_check" @invalid-submit="InvalidSubmit" v-bind:validation-schema="schema">
        <fieldset v-if="agreed">
        <table class="vy-form-table">

        <span v-if="kazoku_message" style="font-weight: bold;"><br>{{ kazoku_message }}</span>  
          

        <!-- 氏名（姓） -->
        <template v-if="'username_sei' in disp_list">
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr >
            <th>
                <label for="username_sei">氏名（姓）<span class="vy-required" v-if="'username_sei' in schema_list">（必須）</span></label>
            </th>
            <!-- 登録時 -->
        
              <td style="text-align: left;">

              <!-- v-model="(javascript部分で宣言した変数名)" -->
              <!-- javascript側で変数に変更があった場合、こちらの項目の値も変更される -->
              <!-- 逆にこちらの項目の値を変更すると、変数に代入される-->

              <!-- v-if="(javascript部分で宣言した変数名)" -->
              <!-- v-ifで指定された変数が「True」なら表示、「False」なら非表示 -->
                <Field type="text" class="form-control enter_forcus" id="username_sei" name="username_sei" 
                v-on:change="Background_change('username_sei')"
                placeholder="体験" v-model="username_sei"
                @blur="username_sei_kana"
                @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext"
                maxlength="100"/>
                <span class="by-sub">※入力例：体験</span>
              <!-- エラーメッセージ -->
              <span class="error"><br><ErrorMessage name="username_sei" /></span>

              </td>
          </tr>
        </template>
        <!-- 氏名（名） -->
        <template v-if="'username_mei' in disp_list">
<!--
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
-->
          <tr >
            <th>
                <label for="username_mei">氏名（名）<span class="vy-required" v-if="'username_mei' in schema_list">（必須）</span></label>
            </th>
            <!-- 登録時 -->
        
              <td style="text-align: left;">

              <!-- v-model="(javascript部分で宣言した変数名)" -->
              <!-- javascript側で変数に変更があった場合、こちらの項目の値も変更される -->
              <!-- 逆にこちらの項目の値を変更すると、変数に代入される-->

              <!-- v-if="(javascript部分で宣言した変数名)" -->
              <!-- v-ifで指定された変数が「True」なら表示、「False」なら非表示 -->
                <Field type="text" class="form-control enter_forcus" id="username_mei" name="username_mei" 
                v-on:change="Background_change('username_mei')"
                placeholder="歩羅" v-model="username_mei"
                @blur="username_mei_kana"
                @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext" maxlength="100"/>
                <span class="by-sub">※入力例：歩羅</span>
              <!-- エラーメッセージ -->
              <span class="error"><br><ErrorMessage name="username_mei" /></span>

              </td>
          </tr>
        </template>
       <template v-if="'username_kana_sei' in disp_list">
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <!-- 氏名かな（姓） -->
            <tr>
              <th>
                <label for="username_kana_sei">氏名かな（姓）<span class="vy-required" v-if="'username_kana_sei' in schema_list" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field type="text" class="form-control enter_forcus" id="username_kana_sei" name="username_kana_sei"  
                v-on:change="Background_change('username_kana_sei')"
                placeholder="たいけん" v-model="username_kana_sei" @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext" maxlength="100"/>
                <span class="by-sub">※入力例：たいけん（ひらがな）</span>
                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="username_kana_sei" /></span>
              </td>
            </tr>
          </template>
       <template v-if="'username_kana_mei' in disp_list">
<!--
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
-->
          <!-- 氏名かな（名） -->
            <tr>
              <th>
                <label for="username_kana_mei">氏名かな（名）<span class="vy-required" v-if="'username_kana_mei' in schema_list" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field type="text" class="form-control enter_forcus" id="username_kana_mei" name="username_kana_mei"  
                v-on:change="Background_change('username_kana_mei')"
                placeholder="ぼら" v-model="username_kana_mei" @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext" maxlength="100"/>
                <span class="by-sub">※入力例：ぼら（ひらがな）</span>
                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="username_kana_mei" /></span>
              </td>
            </tr>
          </template>

          <!-- 性別 -->
          <template v-if="'usersex' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th>
                <label for="usersex">性別<span class="vy-required"  v-if="'usersex' in schema_list">（必須）</span></label>
              </th>
              <td>
                  <!-- ラジオボタンの場合、 「v-model」の部分を共通させる-->
                  <!-- 変数「usersex」には、「value」の値を代入することで、そのvalueを持つラジオボタンが指定される -->
                  <div class="form-group" id="usersex" >
                    <div class="form-check form-check-inline">
                      <Field type="radio" class="form-check-input enter_forcus" id="radio1" name="usersex" value="男" v-model="usersex" @keydown.enter.exact.prevent
                      
                          @keyup.enter.prevent="moveNext"/>
                      <label class="form-check-label" for="radio1">男性</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <Field type="radio" class="form-check-input enter_forcus" id="radio2" name="usersex" value="女" v-model="usersex"  @keydown.enter.exact.prevent
                      
                          @keyup.enter.prevent="moveNext"/>
                      <label class="form-check-label" for="radio2">女性</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <Field type="radio" class="form-check-input enter_forcus" id="radio3" name="usersex" value="他" v-model="usersex"  @keydown.enter.exact.prevent
                      
                          @keyup.enter.prevent="moveNext"/>
                      <label class="form-check-label" for="radio3">その他</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="radio4" name="usersex" value="未" v-model="usersex" @keydown.enter.exact.prevent
                        
                          @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="radio4">答えない</label>
                      </div>
                  </div>
                <span class="error"><ErrorMessage name="usersex" /></span>
              </td>
            </tr>
          </template>

          <!-- 生年月日 -->
          <template v-if="'userbirth' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <!-- 生年月日 -->
            <tr>
              <th>
                <label for="userbirth" class="sp_only">
                  生年月日<span class="vy-required" >（必須）</span>
                  <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open(pc_age+'歳未満の方は<b>保護者の同意とお名前</b>が必要です。')" />
                </label>
                <span class="pc_only">
                  <label for="userbirth"  >
                    生年月日<span class="vy-required" >（必須）</span>
                  </label>
                  <span class="balloon_parent ">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon">
                      {{pc_age}}歳未満の方は<b>保護者の同意とお名前</b>が必要です。
                    </span>
                  </span>
                </span>
              </th>
              <td style="text-align: left;">
                <div style="display:flex;align-items: center;">
                  <span class="pc_only">
                    <Field type="date" class="form-control enter_forcus" id="userbirth" name="userbirth" v-model="userbirth" 
                    :min="birth_before95year"
                    :max="birth_before0year"
                    style="max-width:300px"
                    @keydown.enter.exact.prevent
                    v-on:change="Background_change('userbirth');column_set()"
                    @keyup.enter.prevent="moveNext"/>
                  </span>
                  <span class="sp_only">
                    
                    <select name="birth_year" style="height:30px;" class="enter_forcus" id="birth_year"
                      v-on:change="column_set()" v-model="birth_year"  @keydown.enter.exact.prevent>
                        <option v-for:="i in nensu" v-bind:value="(i+start_year)">{{ i+start_year }}</option>
                    </select>
                    
                    <select name="birth_month" style="height:30px;" class="enter_forcus" id="birth_month"
                    v-on:change="column_set()" v-model="birth_month" @keydown.enter.exact.prevent>
                        <option v-for:="m in 12" v-bind:value="m">{{ m }}</option>
                    </select>
                    <select name="birth_day" style="height:30px;" class="enter_forcus" id="birth_day"
                    v-on:change="column_set()" v-model="birth_day"  @keydown.enter.exact.prevent>
                        <option v-for:="d in 31" v-bind:value="d">{{ d }}</option>
                    </select>


                  </span>
                  <div style="font-size:17px">（{{setAge(userbirth)}} 歳）</div>
                </div>
                <!-- エラーメッセージ -->
                <span class="error"><ErrorMessage name="userbirth" /></span>
              </td>
            </tr>
          </template>
          <!-- 郵便番号 -->
         <template v-if="'yubin' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th>
                <label for="yubin">郵便番号<span class="vy-required" >（必須）</span></label>
                        
                        <!--
                <span class="sp_only" style="color:red">
                  <b>
                ※ 令和7年7月4日：アンドロイドご利用のお客様へ<br>
                一部ブラウザ（Yahooなど）でエラーが発生し、登録ができなくなることが報告されました。恐れ入りますが、ブラウザはChrome（推奨）をご使用下さい。 <br>
                （画面右下のマイページをタップして一旦ログアウトをお願いします。） 
                  </b>
                </span>
                -->
              </th>
              <td style="text-align: left;">
                <div style="display: flex;align-items: center;">
                <Field type="tel" class="form-control enter_forcus" id="yubin" name="yubin"   maxlength="7" placeholder="3501234" v-model="yubin"
                style="width:100px;margin-right:10px"
                v-on:keyup="Search_address" v-on:change="Background_change('yubin');Search_address" @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext"/> <a href="https://www.post.japanpost.jp/zipcode/" target="_blank">郵便番号検索</a>
                </div>
                <span class="by-sub">※入力例：3501234（ハイフン無し）</span>
                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="yubin" /></span>
              </td>
            </tr>
          </template>
          <!-- 住所 -->
          <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
            <tr>
              <th>
                <label for="address_kencd">住所（都道府県）<span class="vy-required"  >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <div class="form-group">
                  <!--
                  {{ GlobalData.$Address_ken_list[address_kencd] }}
                  -->
                  <Field as="select" name="address_kencd"  class="form-select enter_forcus" id="address_kencd" v-model="address_kencd"  @keydown.enter.exact.prevent
                  v-on:change="Background_change('address_kencd')"
                          @keyup.enter.prevent="moveNext">
                            <option value="" selected></option>  <!-- 必須項目チェックのため"0"ではなく""とする -->
                            <option v-for:="i in GlobalData.$Address_ken_list.length-1" v-bind:value="i">{{ GlobalData.$Address_ken_list[i]}}</option>
                  </Field>
                </div>
                <!-- エラーメッセージ -->
                <span class="error"><ErrorMessage name="address_kencd"/></span> 
              </td>
          </tr>
          <tr>
              <th>
                <label for="address_shi">住所（市町村）<span class="vy-required" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <!--
                {{ address_shi }}
                --> 
                <Field type="text" class="form-control enter_forcus" id="address_shi" name="address_shi" 
                v-on:change="Background_change('address_shi')"
                v-model="address_shi"  @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext" maxlength="100"/>
                <span class="by-sub">※入力例：川越市新富町</span>

                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="address_shi" /></span>
              </td>
          </tr>
          <template v-if="'address_banchi' in disp_list">
          <tr>
              <th>
                <label for="address_banchi">住所（番地以降）<span class="vy-required" v-if="'address_banchi' in schema_list" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field type="text" class="form-control enter_forcus" id="address_banchi" name="address_banchi"  
                v-on:change="Background_change('address_banchi')"
                  v-model="address_banchi"   @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext" maxlength="100"/>
                <span class="by-sub">※入力例：１－１－１</span>
                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="address_banchi" /></span>
              </td>
          </tr>
        </template>
      <!-- 電話番号1 -->
      <template v-if="'usertel1' in disp_list">
          <tr>
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>

          <!-- 電話番号1 -->
          <tr>
            <th>
              <label v-if="'usertel2' in disp_list" for="usertel1">電話番号1<span class="vy-required"  v-if="'usertel1' in schema_list" >（必須）</span></label>
              <label v-else for="usertel1">電話番号<span class="vy-required"  v-if="'usertel1' in schema_list" >（必須）</span></label>
            </th>
            <td style="text-align: left;">
              <Field type="tel" class="form-control enter_forcus" id="usertel1" name="usertel1" 
              v-on:change="Background_change('usertel1')"
                placeholder="0492123456" maxlength="11" v-model="usertel1"
                @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext"/>
              <span class="by-sub">※入力例：0492123456（ハイフン、スペース無し）</span>
              <!-- エラーメッセージ -->
              <span class="error"><ErrorMessage name="usertel1" /></span>
            </td>
            </tr>
            
        </template>
          
        <!-- 電話番号2 -->
        <template v-if="'usertel2' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th>
                <label for="usertel2">電話番号2<span class="vy-required"  v-if="'usertel2' in schema_list" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
              <Field type="tel" class="form-control enter_forcus" id="usertel2" name="usertel2" 
              v-on:change="Background_change('usertel2')"
                placeholder="0492123456" maxlength="11" v-model="usertel2"
                @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext"/>
              <span class="by-sub">※入力例：0492123456（ハイフン、スペース無し）</span>
              <!-- エラーメッセージ -->
              <span class="error"><ErrorMessage name="usertel2" /></span>
              </td>
            </tr>
          </template>
          
          <!-- 保護者名と保護者電話番号（pc_age歳未満の場合のみ表示） -->
          <template v-if="getAge(userbirth) < pc_age">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            
            <tr>
              <th>
                <!-- pc_age歳未満なら（必須）を表示 -->
                <label for="parent_name">保護者のお名前<span class="vy-required">（{{pc_age}}歳未満の場合は必須）</span></label>
              </th>
              <td style="text-align: left;">
              <Field type="text" class="form-control enter_forcus" id="parent_name" name="parent_name" 
                v-on:change="Background_change('parent_name')"
                v-model="parent_name"  @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext" maxlength="100"/>
                <!-- エラーメッセージ -->
                <span class="error"><ErrorMessage name="parent_name" /></span>
              </td>
            </tr>
            <template v-if="'hogosyatel' in disp_list ">
              <tr>
                <th>
                  <!-- 必須入力に指定されていて、なおかつpc_age歳未満なら（必須）を表示 -->
                  <label for="hogosyatel">保護者電話番号<span class="vy-required"  v-if="'hogosyatel' in schema_list" >（{{pc_age}}歳未満の場合は必須）</span></label>
                </th>
                <td style="text-align: left;">
                <Field type="tel" class="form-control enter_forcus" id="hogosyatel" name="hogosyatel" 
                v-on:change="Background_change('hogosyatel')"
                  placeholder="0492123456" maxlength="11" v-model="hogosyatel"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                <span class="by-sub">※入力例：0492123456（ハイフン、スペース無し）</span>
                <!-- エラーメッセージ -->
                <span class="error"><ErrorMessage name="hogosyatel" /></span>
                </td>
              </tr>

            </template>
          </template>

          <!--体験者区分-->
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
                  
            <th>
              
                <label for="shokugyo_kbn" class="sp_only">
                  体験者区分<span class="vy-required" >（必須）</span>
                  <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('体験プログラムの参加条件に関わりますので、登録後は変更できません。<br>あらかじめご了承ください。')" />
                </label>
                <span class="pc_only">
                  <label for="shokugyo_kbn"  >
                    体験者区分<span class="vy-required" >（必須）</span>
                  </label>
                  <span class="balloon_parent ">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon"  style="min-width:600px">
                      体験プログラムの参加条件に関わりますので、登録後は変更できません。<br>あらかじめご了承ください。
                    </span>
                  </span>
                </span>
            </th>
              <td style="text-align: left;">
              <span v-if="type=='henshu'">

                <span v-if="shokugyo_kbn == 0">
                  <Field type="radio" class="form-check-input enter_forcus" id="shokugyo_kbn1" name="shokugyo_kbn" value="0" v-model="shokugyo_kbn"
                        v-on:change="change_kbn()"
                        @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="shokugyo_kbn1">学生</label>
                </span>
                
                <span v-else-if="shokugyo_kbn == 1">
                  <Field type="radio" class="form-check-input enter_forcus" id="shokugyo_kbn2" name="shokugyo_kbn" value="1" v-model="shokugyo_kbn"
                        v-on:change="change_kbn()"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="shokugyo_kbn2">一般</label>
                </span>
                <span style="color:red">
                <br>※変更が必要な場合は社会福祉協議会にお問い合わせください。</span>
              </span>

              <span v-else>
                <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="shokugyo_kbn1" name="shokugyo_kbn" value="0" v-model="shokugyo_kbn"
                        v-on:change="change_kbn()"
                        @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="shokugyo_kbn1">学生</label>
                </div>
                <!--「一般」は、学生以外の参加が「有り」の時のみ表示-->
                <div class="form-check form-check-inline" v-if="other_sanka == 1">
                        <Field type="radio" class="form-check-input enter_forcus" id="shokugyo_kbn2" name="shokugyo_kbn" value="1" v-model="shokugyo_kbn"
                        v-on:change="change_kbn()"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="shokugyo_kbn2">一般</label>
                </div>
                <span style="color:red">
                <br>※登録後は変更できません。</span>
              </span>
              </td>
            </tr>
          

            <template  v-if="shokugyo_kbn == '1'">
              
              <!-- 一般区分 -->
                <tr>
                  <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr>
                <th>
                    <label for="ippan_kbn">
                      一般区分<span class="vy-required" >（必須）</span>
                    </label>
                </th>
                <td style="text-align: left;display:flex">
                  <Field as="select" name="ippan_kbn"  class="form-select enter_forcus" id="ippan_kbn" v-model="ippan_kbn" 
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext">
                              <option v-bind:value="0">{{ ippan_select[0]}}</option>
                              <option v-for:="i in ippan_select.length-1" v-bind:value="i">{{ ippan_select[i]}}</option>
                    </Field>
                  <!-- エラーメッセージ -->
                  <span class="error" style="margin-left:10px;display: flex;"><br><ErrorMessage name="ippan_kbn" /></span>
                  </td>
              </tr>
            </template>
              
           
          <template v-if="shokugyo_kbn == 0">
            <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <!-- 学生区分 -->
            <tr>
              <th>
                <label for="gakusei_kbn" class="sp_only">
                  学生区分<span class="vy-required" >（必須）</span>
                  <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('体験プログラムの参加条件に関わりますので、登録後は変更できません。<br>あらかじめご了承ください。')" />
                </label>
                <span class="pc_only">
                  <label for="gakusei_kbn"  >
                    学生区分<span class="vy-required" >（必須）</span>
                  </label>
                  <span class="balloon_parent ">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="min-width:600px">
                      体験プログラムの参加条件に関わりますので、登録後は変更できません。<br>あらかじめご了承ください。
                    </span>
                  </span>
                </span>
              </th>
              <td style="text-align: left;">
              
                <!-- 編集時、または職業区分が一般の時は固定 -->
                <span v-if="type=='henshu'">
                    {{gakusei_meisho_list[gakusei_kbn]}}
                  <span style="color:red">
                    <br>※変更が必要な場合は社会福祉協議会にお問い合わせください。</span>
                </span>
                
                <span  v-else>
                      
                  <Field  v-if="shokugyo_kbn == 1" as="select" class="form-select enter_forcus"
                    v-on:change="Background_change('gakusei_kbn')"
                    name="gakusei_kbn" id="gakusei_kbn" v-model="gakusei_kbn" style="width: 100px;float: left;" >
                    <option  v-bind:value="7">一般</option>
                  </Field>
                  <Field v-else as="select" class="form-select enter_forcus"
                    v-on:change="Background_change('gakusei_kbn')"
                    name="gakusei_kbn" id="gakusei_kbn" v-model="gakusei_kbn" style="float: left;" >
                    <option value="">--</option>
                    <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                      <template v-if="gakusei_kbn_list[i] != 0">
                        <option v-bind:value="i">{{ gakusei_meisho_list[i]}}</option>
                      </template>
                    </template>
                  <!--
                    <option v-for:="i in gakusei_kbn_list.length" v-bind:value="i-1">{{ gakusei_kbn_list[i-1]}}</option>
                -->
                  </Field>
                  <br>
                  <span style="color:red">
                    <br>※登録後は変更できません。
                  </span>
                    <!-- エラーメッセージ -->
                    <span class="error" style="margin-left:10px;display: flex;"><ErrorMessage name="gakusei_kbn" /></span>
                
                </span>
                </td>
            </tr>
           </template>
            
          <!-- 学校名 -->
          <template v-if="shokugyo_kbn == 0">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
          
            <tr>
              <th>
                  <label for="gakko_name">
                    学校名<span class="vy-required">（必須）</span>
                  </label>
              </th>
              <td style="text-align: left;">
                <Field type="text" class="form-control enter_forcus" id="gakko_name" name="gakko_name" 
                  placeholder="体験第一高校" v-model="gakko_name"
                  v-on:change="Background_change('gakko_name')"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext" maxlength="100"/>
              <span class="by-sub">※入力例：体験第一高校</span>
                <!-- エラーメッセージ -->
                <span class="error"><br><ErrorMessage name="gakko_name" /></span>
                </td>
            </tr>
          </template>
          <!-- 学年 -->
          <template v-if="shokugyo_kbn == 0">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th>
                  <label for="gakunen">
                    学年<span class="vy-required" >（必須）</span>
                  </label>
              </th>
              <td style="text-align: left;display: flex;align-items: center;">
              
                <Field as="select" class="form-select enter_forcus"
                  v-on:change="Background_change('gakunen')"
                  name="gakunen" id="gakunen" v-model="gakunen" style="width: 70px;float: left;" >
                          <option value="">--</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                </Field> 年
                <!-- エラーメッセージ -->
              </td>
              <span class="error" ><ErrorMessage name="gakunen" /></span>
            </tr>
          </template>
          
            <!-- 趣味・特技・資格 -->
          <template v-if="'shikaku' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            
            <tr>
              <th>
                <label for="shikaku">
                  趣味・特技・資格
                  <span class="vy-required" v-if="'shikaku' in schema_list">（必須）</span>
                </label>
              </th>
              <td style="text-align: left;">
                  <!--textareaは通常「enter」のみで改行だが、エンターをフォーカス移動に利用しているので、「enter + alt」で改行するようにする（改行処理はNewLine_shikaku関数で行う）-->
                  <!--textareaの場合は、enterのkeydown時ではなく、keyup時にフォーカス移動するようにする（「enter + alt」と同時に発火してしまうため）-->
                <Field as="textarea" class="form-control enter_forcus" id="shikaku" name="shikaku" rows="3" v-model="shikaku"
                  v-on:change="Background_change('shikaku')"
                 maxlength="5000"></Field>
                  <span class="by-sub">※改行は「alt + Enter」で行います。</span>
                  <!-- エラーメッセージ -->
                  <span class="error" ><ErrorMessage name="shikaku" /></span>
                <!--
                @keydown.enter.exact.prevent
                @keyup.enter.exact="moveNext"
                @keydown.enter.alt.exact="NewLine_shikaku" 
                    <span class="by-sub">※改行は「alt + Enter」で行います。</span>-->
              </td>
            </tr>
          </template>

            <!-- 応募動機と活動への意気込み -->
             <!--
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            
            <tr>
              <th>
                <label for="douki">応募動機と活動への意気込み<span class="vy-required">（必須）</span></label>
              </th>
              <td style="text-align: left;">
                  <Field as="textarea" class="form-control enter_forcus" id="douki" name="douki" rows="3" v-model="douki"
                maxlength="5000"></Field>
              <span class="error" ><ErrorMessage name="douki" /></span>
              </td>
            </tr>-->
            <tr v-if="type!='henshu'">
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <!-- 初回登録年月日 -->
            <tr v-show="type!='henshu'">
              <th>
                <label for="touroku_date">初回登録年月日</label>
              </th>
              <td style="text-align: left;">

                {{DateYearSetting(touroku_date)}}
             
              </td>
            </tr>
            <!-- ボランティア活動経験 -->
            <template v-if="'katsudou_flg' in disp_list">
              <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr>
                <th>
                  <label for="katsudou_flg">ボランティア活動経験
                    <span class="vy-required" v-if="'katsudou_flg' in schema_list">（必須）</span></label>
                </th>
                <td style="text-align: left;">
                  <div class="form-group" id="katsudou_flg" >
                      <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="experience_radio1" name="katsudou_flg" :value="true" v-model="katsudou_flg"
                        
                          @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="experience_radio1">有り</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="experience_radio2" name="katsudou_flg" :value="false" v-model="katsudou_flg"
                        
                          @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="experience_radio2">無し</label>
                      </div>
                  </div>

                  <!-- エラーメッセージ -->
                  <span class="error"><ErrorMessage name="katsudou_flg" /></span>
                </td>
              </tr>
              
            
      <!-- 活動内容（活動経験がtrueの場合のみ表示） -->
              <tr v-if="katsudou_flg==true">
                <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr v-if="katsudou_flg==true">
                <th>
                    <label for="katsudou_naiyo">ボランティア活動内容
                      <span class="vy-required"  v-if="'katsudou_flg' in schema_list">（必須）</span></label>
                </th>
                <td style="text-align: left;">
                    
                    <Field as="textarea" class="form-control enter_forcus" id="katsudou_naiyo" name="katsudou_naiyo" rows="3" v-model="katsudou_naiyo"
                    v-on:change="Background_change('katsudou_naiyo')"
                    maxlength="5000"></Field>

                      <!--
                      <span class="by-sub">※改行は「alt + Enter」で行います。</span>
                      
                      @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"
                      @keydown.enter.alt.exact="NewLine_katsudou_naiyo" -->

                    
                </td>
              </tr>
              
            </template>
    
            <template v-if="'smartphone' in disp_list">
              <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>

            <tr>
              
              <th>
                <label for="smartphone">当日のスマートフォンの使用<span class="vy-required"  v-if="'smartphone' in schema_list">（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="smart_radio1" name="smartphone" value="true" v-model="smartphone"
                        @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="smart_radio1">可</label>
                  </div>
                <div class="form-check form-check-inline">
                        <Field type="radio" class="form-check-input enter_forcus" id="smart_radio2" name="smartphone" value="false" v-model="smartphone"
                        @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>
                        <label class="form-check-label" for="smart_radio2">不可</label>
                  </div>
                  <br>
                  <span class="error" >※小さなお子様など、体験先でスマートフォンが利用できないときは「不可」としてください。</span>
              </td>
              </tr>
            </template>

          <!-- フリー項目（テキスト1） -->
          <template v-if="'free_text1' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
            <tr>
              <th>
                <label for="free_text1">{{ user_free_text1 }}<span class="vy-required" v-if="'free_text1' in schema_list">（必須）</span></label>
              </th>
              <td style="text-align: left;">

                
                
                <Field type="text" class="form-control enter_forcus" id="free_text1" name="free_text1"  
                  v-model="free_text1" @keydown.enter.exact.prevent
                  v-on:change="Background_change('free_text1')"
                @keyup.enter.prevent="moveNext" />
                <!-- エラーメッセージ -->
                <span class="error"> <ErrorMessage name="free_text1" /></span>
              </td>
            </tr>
          </template>
            
            <template v-if="'free_text2' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <!-- フリー項目（テキスト2） -->
            <tr>
              <th>
                <label for="free_text2">{{ user_free_text2 }}<span class="vy-required" v-if="'free_text2' in schema_list">（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field type="text" class="form-control enter_forcus" id="free_text2" name="free_text2"  
                  v-on:change="Background_change('free_text2')"
                  v-model="free_text2" @keydown.enter.exact.prevent
                @keyup.enter.prevent="moveNext" />
                <!-- エラーメッセージ -->
                <span class="error"> <ErrorMessage name="free_text2" /></span>
              </td>
            </tr>
          </template>
          
          <!-- フリー項目（選択1） -->
          <template v-if="'free_choice1' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
            <tr>
              <th>
                <label for="free_choice1">{{ user_free_select1 }}<span class="vy-required" v-if="'free_choice1' in schema_list">（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field as="select" name="free_choice1"  class="form-select enter_forcus" id="free_choice1" v-model="free_choice1"
                  v-on:change="Background_change('free_choice1')"
                  @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext">
                            <option v-bind:value="0">{{ user_free_choice1[0]}}</option>
                            <option v-for:="i in user_free_choice1.length-1" v-bind:value="i">{{ user_free_choice1[i]}}</option>
                  </Field>
                  
                <!-- エラーメッセージ -->
                <span class="error"> <ErrorMessage name="free_choice1" /></span>
              </td>
            </tr>
          </template>
          
          <template v-if="'free_choice2' in disp_list">
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
          <!-- フリー項目（選択2） -->
            <tr>
              <th>
                <label for="free_choice2">{{ user_free_select2 }}<span class="vy-required" v-if="'free_choice2' in schema_list">（必須）</span></label>
              </th>
              <td style="text-align: left;">
                <Field as="select" name="free_choice2"  class="form-select enter_forcus" id="free_choice2" v-model="free_choice2"
                    v-on:change="Background_change('free_choice2')"
                    @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext">
                          <option v-bind:value="0">{{ user_free_choice2[0]}}</option>
                            <option v-for:="i in user_free_choice2.length-1" v-bind:value="i">{{ user_free_choice2[i]}}</option>
                  </Field>
                <!-- エラーメッセージ -->
                <span class="error"> <ErrorMessage name="free_choice2" /></span>
              </td>
            </tr>
          </template>
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>

          <template v-if="type!='henshu'" >

          
          <tr v-show="getAge(userbirth) < pc_age">
            <td colspan="2">
              {{pc_age}}歳未満の場合、保護者の同意が得られていますか？<span class="vy-required" >（同意を得られない場合、登録できません。）</span><br/>
              <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input enter_forcus" id="parent_radio1" name="parent_consent" value="true" v-model="parent_consent"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="parent_radio1">はい</label>
              </div>
              <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input enter_forcus" id="parent_radio2" name="parent_consent" value="false" v-model="parent_consent"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="parent_radio2">いいえ</label>
              </div>
            </td>
          </tr>
            <tr v-show="getAge(userbirth) < pc_age">
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>

          <tr>
            <td colspan="2"><input type="checkbox" class="form-check-input" name="riyo_kiyaku" v-model="doui_kiyaku"/>
                    利用規約に同意する<span class="vy-required" >（必須）</span><br/>
                    <div style="color:red" v-if="!kiyaku_doui_check">同意が必要です。</div>
                    <div style="text-decoration:underline;cursor:pointer;text-align:right"  @keyup.enter.prevent="moveNext">
                    <span v-on:click="kiyaku">利用規約を参照</span></div>
            </td>
          </tr>
            <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>

          <tr>
            <td colspan="2"><input type="checkbox" class="form-check-input"  name="privacy_policy" v-model="doui_policy"/>
                    プライバシーポリシーに同意する<span class="vy-required" >（必須）</span><br/>
                    <div style="color:red" v-if="!policy_doui_check">同意が必要です。</div>
                    <div style="text-decoration:underline;cursor:pointer;text-align:right">
                      <span  v-on:click="policy">
                        プライバシーポリシーを参照
                      </span>
                    </div>
            </td>
          </tr>
        </template>
        </table>
        <input type="submit" value="確認" align="center" style="width:200px;height:50px" class="btn btn-primary"/>
        </fieldset>
      </Form>
    </div>
    <div v-if="mode=='confirm'">
      <!--  スマホの場合は、左側に「入力に戻る」、右側に「登録」「保存」 -->
      <div v-if="isSP">      
        <button class="btn btn-secondary"
          style="width: 150px; height: 50px;padding: 0;margin:5px;background-color:#FF6F00;color:white;border:#FF6F00;text-align:center"
          v-on:click="ReturnProc()">入力に戻る
        </button>
        <button class="btn btn-primary"
          style="width:150px;height:50px;padding:0;margin:5px;background-color:#0066FF;color:white;border:#0066FF;text-align:center"
          v-on:click="TorokuProc()">{{ button_mongon }}
        </button>
      </div>  
      <!--  ＰＣの場合は、左側に「登録」「保存」、右側に「入力に戻る」 -->
      <div v-else>      
        <button class="btn btn-primary"
          style="width:150px;height:50px;padding:0;margin:5px;background-color:#0066FF;color:white;border:#0066FF;text-align:center"
          v-on:click="TorokuProc()">{{ button_mongon }}
        </button>
        <button class="btn btn-secondary"
          style="width: 150px; height: 50px;padding: 0;margin:5px;background-color:#FF6F00;color:white;border:#FF6F00;text-align:center"
          v-on:click="ReturnProc()">入力に戻る
        </button>
      </div>  
    </div>
    <div v-if="mode=='ninsyo'">
      <p>ご登録いただいたメールアドレスに認証番号をお送りしましたので、以下に入力して下さい。</p><br/><br/>
      認証番号：<input v-model="ninsyo_no"/><br/><br/>
      <button class="btn shadow" v-on:click="ninsyo" style="text-align:center">認証番号の照合</button><br/><br/>
    </div>
    <div v-if="mode=='kanryo'">
      <p>ユーザ情報の登録が完了しました。</p><br/><br/>
      <a v-on:click="home" class="btn btn-primary">戻る</a>
    </div>
  </div>

        <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
        <div class="vy-responsive-menu-container floating_over"  v-if="type=='henshu'" style="
          margin-bottom: 50px;
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000;text-align:center"  v-on:click="mypage()">戻る</button>
          
      </div>

  
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"
                @logout_move_login="logout_move_login"/>
</template>

<script setup>
/* eslint-disable */

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

import { ref, watch, watchEffect, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useRouter,useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute();
const cityname = route.params.shakyo
import { Field, Form, ErrorMessage } from 'vee-validate'
import * as yup from 'yup';
import { GlobalData, login_check,Kokai_setting } from '../js/userdata.js';
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import AWS from 'aws-sdk'
import axios from 'axios'

import * as AutoKana from 'vanilla-autokana'   // 漢字のかな項目への自動入力

// かな自動入力は、ShakyoUserDetail.vueの方でも行っているので、こちらで修正した時は必ずShakyoUserDetail.vueも見直してください。
let autokana_sei = null  // 苗字のかな自動入力のための項目同士の紐付け(bind)
let autokana_mei = null  // 名前のかな自動入力のための項目同士の紐付け(bind)

const attributes = ref([{
  title : "YYYY MMMM"
}])

import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

let subject_id = null;   // 複数ユーザー対応 サブジェクトID

const emit = defineEmits(['call'])

const agreed = ref(false);  //同意するまで画面御入力を禁止するフラグ

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

let Shakyo_data
// 市区町村コード
let choson_code = ""
let user_add_message = ref(null)

let url = GlobalData.$API_URL

let ID_Token_error = 0

// スマホかＰＣかの判定   true:スマホ false:PC
let isSP = ref(window.matchMedia("(max-width: 960px)").matches)

// ログイン状態の確認
let check_ID_Token =  function(){

  // ログインが確認できない場合
  if (GlobalData.$User_email  == null) {
        // ローディングアイコン表示
        emit('call', { cmd:"loading_start" })
        login_check();
        if(ID_Token_error == 6){
            emit('call', { cmd:'loading_end_noreload'})
            message.value = "ログイン状態が確認できませんでした。\n\n※どうしてもログイン状態にならない場合は、ブラウザのキャッシュを削除して、もう一度ログインください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "retry_error";
            contentMessage.value = MessageModal
            return
        }else{
            ID_Token_error++
            setTimeout(function(){check_ID_Token()},"1000")

        }
    
  }else{
    emit('call', { cmd:'loading_end_noreload'})
  }
}

check_ID_Token()

const mode = ref('toroku')
const passvisi = ref(false)
const passtype = ref("password")
//const button_text = ref('　　送信　　')
const doui_kiyaku = ref(false)
const doui_policy = ref(false)
const parent_doui_check = ref(true)
const kiyaku_doui_check = ref(true)
const policy_doui_check = ref(true)
const ninsyo_no = ref('')
const post = ref('')
const kencd = ref('')
const city = ref('')

// 保存ボタンの文言
let button_mongon = ref("登録")

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]

// user：ユーザー情報（プロフィール編集時のみ）
// type：henshu = プロフィール編集、それ以外は新規登録
// cityname：所属社協
// user_flg、disp_flg、hissu_flg：項目設定フラグ
// user_free_〇〇：フリー項目
// other_sanka：学生以外の参加　1:有、2:無
const props = defineProps(['param'])

// 要不要フラグ
let user_flg = ref(props.param.user_flg)
// 表示フラグ
let disp_flg = ref(props.param.disp_flg)
// 必須フラグ
let hissu_flg = ref(props.param.hissu_flg)

// 保護者同意年齢
let pc_age = ref(props.param.pc_age)

/* フリー項目編集の内容 */
// フリー項目テキスト１のタイトル
let user_free_text1 = ref(props.param.user_free_text1)
// フリー項目テキスト２のタイトル
let user_free_text2 = ref(props.param.user_free_text2)
// フリー項目選択１のタイトル
let user_free_select1 = ref(props.param.user_free_select1)
// フリー項目選択２のタイトル
let user_free_select2 = ref(props.param.user_free_select2)
// フリー項目選択１の選択肢
let user_free_choice1 = ref(props.param.user_free_choice1)
// フリー項目選択２の選択肢
let user_free_choice2 = ref(props.param.user_free_choice2)
// 一般区分の選択肢
let ippan_select = ref(props.param.ippan_select)

// 学生区分の利用可不可と名称
let gakusei_kbn_list = ref(props.param.gakusei_kbn_list)
let gakusei_meisho_list = ref(props.param.gakusei_meisho_list)


// 学生以外の参加　2の時は学生で固定
let other_sanka = ref(props.param.other_sanka)

// 親コンポーネント（main）から送られてきた配列。体験ユーザーの情報が入っている。
let taikenuser = []
if(props.param.user != undefined){
  taikenuser = props.param.user
}

let kazoku_message = ref('')
// 家族の人数
let family_count = 0
if(props.param.family_count != undefined){
  family_count = props.param.family_count + 1
  kazoku_message.value = family_count + '番目のユーザー情報を登録して下さい。'
}
// 家族（複数人）登録時は、郵便番号・住所や電話番号(登録対象が未成年だった時の保護者電話番号に使用) 登録時の初期値の設定に使用する。
let accountuser = []
if(props.param.accountuser != undefined){
  accountuser = props.param.accountuser
}

// ログイン後のプロフィール登録確認画面を表示する。
// ログイン後の右メニューから起動されたフラグ True：右メニューから  False：通常の新規登録
let multipleprofile = props.param.multipleprofile

/* データベース項目。APIから受け取る、または送信する値 */
/* 分かりやすいようにDBのカラム名と同じ変数名にすること*/
// 体験ユーザーテーブルの項目
let taikenuser_id = ref(0)
let username_sei = ref("") // 氏名（姓）　※表示は姓名は別々にする
let username_mei = ref("") // 氏名（名）　※表示は姓名は別々にする
// let username = ref("") // 氏名
let username_kana_sei = ref("") // 氏名かな（姓）　※表示は姓名は別々にする
let username_kana_mei = ref("") // 氏名かな（名）　※表示は姓名は別々にする
// let username_kana = ref("") // 氏名かな

let userbirth = ref("2010-01-01")  // 生年月日
// 生年月日のプルダウンメニューを作成する  スマホ用の生年月日
let birth_year = ref(2010)
let birth_month = ref(1)
let birth_day = ref(1)

let usersex = ref("未")
let yubin = ref("")
let address_kencd = ref("")
let address_shi = ref("")
let address_banchi = ref("")
let shokugyo_kbn = ref("0")
let gakusei_kbn = ref("")
let ippan_kbn = ref(0)
let gakko_name = ref("")
let gakunen = ref("")
let katsudou_flg = ref(false)
let katsudou_naiyo = ref("")
let usertel1 = ref("")
let usertel2 = ref("")
let hogosyatel = ref("")
let shikaku = ref("")
let douki = ref("")
let touroku_date = ref("")
let parent_consent = ref(false)
let parent_name = ref("")
let smartphone = ref(true)
let syomei_kahi = ref(true)
let sending = ref(1)
let free_text1 = ref("")
let free_text2 = ref("")
let free_choice1 = ref(0)
let free_choice2 = ref(0)
/*
let kikaku_list = ["彩の国だより","SAI","市町村（行政）広報誌","市町村社協広報誌",
                  "埼玉新聞","その他の新聞","インターネット","ラジオ","ポスター・チラシ",
                  "先生から聞いて","親から聞いて","友達から聞いて","その他"]
let kikaku_set_list = ref([false,false,false,false,false,false,false,false,false,false,false,false,false])
let kikaku_poster = ref("")
let kikaku_other = ref("")

let iyoku_list = ["ぜひ参加したい","機会があれば参加したい","参加しない","どちらともいえない"]
let sanka_iyoku = ref(0)
*/
// 今日の日付データを変数hidukeに格納
const hiduke = new Date(); 

let nensu = 97 
let start_year = hiduke.getFullYear() - 97;

// 年・月・日を取得する
const year = hiduke.getFullYear();
const before0year = hiduke.getFullYear();
const before95year = hiduke.getFullYear()-96;
const month = hiduke.getMonth()+1;
const day = hiduke.getDate();
// 生年月日カレンダーは0～95歳まで選択できるようにする
let birth_before0year = before0year+"-"+("000"+month).slice( -2 )+"-"+("000"+day).slice( -2 )
let birth_before95year = before95year+"-"+("000"+month).slice( -2 )+"-"+("000"+(day+1)).slice( -2 )

// どこからこのコンポーネントを呼び出したか（toroku または 未指定　→　新規、henshu →　プロフィール編集）
let type = "toroku"
if(props.param.type != undefined){
  type = props.param.type

  if(type == "henshu"){
    button_mongon.value = "保存"

    //体験ユーザー名
    if(taikenuser["username"] != "None"){
      let u_parts = taikenuser["username"].trim().split(/\s+/)
      username_sei.value = u_parts[0];
      if(u_parts.length <= 1){
        username_mei.value = '';
      } else {
        username_mei.value = u_parts[1];
      }
    }

    //体験ユーザー名（かな）
    if(taikenuser["username_kana"] != "None"){
      let uk_parts = taikenuser["username_kana"].trim().split(/\s+/)
      username_kana_sei.value = uk_parts[0];
      if(uk_parts.length <= 1){
        username_kana_mei.value = '';
      } else {
        username_kana_mei.value = uk_parts[1];
      }
    }

    //生年月日
    if(taikenuser["userbirth"] != "None"){
      userbirth.value = taikenuser["userbirth"];
      
        // 日付データを変数hidukeに格納
        const hiduke = new Date(userbirth.value); 

        // 年・月・日を取得する
        birth_year.value = hiduke.getFullYear();
        birth_month.value = hiduke.getMonth()+1;
        birth_day.value = hiduke.getDate();

     }

    //性別
    if(taikenuser["usersex"] != "None"){
      usersex.value = taikenuser["usersex"];
    }

    //郵便番号
    if(taikenuser["yubin"] != "None"){
      yubin.value = taikenuser["yubin"];
    }

    //都道府県コード
    if(taikenuser["address_kencd"] != "None" && taikenuser["address_kencd"] != "" && taikenuser["address_kencd"] != null){
      address_kencd.value = taikenuser["address_kencd"];
    }

    //市町村
    if(taikenuser["address_shi"] != "None"){
      address_shi.value = taikenuser["address_shi"];
    }

    //町域番地以降
    if(taikenuser["address_banchi"] != "None"){
      address_banchi.value = taikenuser["address_banchi"];
    }
    //電話番号1
    if(taikenuser["usertel1"] != "None"){
      usertel1.value = taikenuser["usertel1"];
    }
    //電話番号2
    if(taikenuser["usertel2"] == null){
    }else if(taikenuser["usertel2"].trim() != "None"){
      usertel2.value = taikenuser["usertel2"];
    }


    //保護者電話番号
    if(taikenuser["hogosyatel"] == null){

    }else if(taikenuser["hogosyatel"].trim() != "None"){
      hogosyatel.value = taikenuser["hogosyatel"];
    }

    //趣味・特技・資格
    if(taikenuser["shikaku"] != "None"){
      shikaku.value = taikenuser["shikaku"];
    }
    //応募動機と活動への意気込み
    if(taikenuser["douki"] != "None"){
      douki.value = taikenuser["douki"];
    }

    //ボランティア活動経験
    if(taikenuser["katsudou_flg"] != "None"){
      katsudou_flg.value = taikenuser["katsudou_flg"];
    }

    //ボランティア活動内容
    if(taikenuser["katsudou_naiyo"] != "None"){
      katsudou_naiyo.value = taikenuser["katsudou_naiyo"];
    }
    //職業区分
    if(taikenuser["shokugyo_kbn"] != "None" && taikenuser["shokugyo_kbn"] != "" && taikenuser["shokugyo_kbn"] != null){
      shokugyo_kbn.value = taikenuser["shokugyo_kbn"];
    }

    //学生区分
    if(taikenuser["gakusei_kbn"] != "None"){
      gakusei_kbn.value = taikenuser["gakusei_kbn"];
    }

    //一般区分
    if(taikenuser["ippan_kbn"] != "None"){
      ippan_kbn.value = taikenuser["ippan_kbn"];
    }

    //学校名
    if(taikenuser["gakko_name"] != "None"){
      gakko_name.value = taikenuser["gakko_name"];
    }

    //学年
    if(taikenuser["gakunen"] != "None"){
      gakunen.value = taikenuser["gakunen"];
    }
    //親の同意
    if(taikenuser["parent_consent"] != "None"){
      parent_consent.value = taikenuser["parent_consent"];
    }
    //親の名前
    if(taikenuser["parent_name"] != "None"){
      parent_name.value = taikenuser["parent_name"];
    }

    //当日のスマートフォンの使用可不可
    if(taikenuser["smartphone"] != "None"){
      smartphone.value = String(taikenuser["smartphone"]);
    }

    //フリー項目（テキスト1）
    if(taikenuser["free_text1"] != "None"){
      free_text1.value = taikenuser["free_text1"];
    }
    //フリー項目（テキスト2）
    if(taikenuser["free_text2"] != "None"){
      free_text2.value = taikenuser["free_text2"];
    }
    //フリー項目（選択1）
    if(taikenuser["free_choice1"] != "None" && taikenuser["free_choice1"] != null){
      free_choice1.value = taikenuser["free_choice1"];
    }
    //フリー項目（選択2）
    if(taikenuser["free_choice2"] != "None" && taikenuser["free_choice2"] != null){
      free_choice2.value = taikenuser["free_choice2"];
    }

    /*
    //参加証明書の要否
    if(taikenuser["syomei_kahi"] != "None"){
      syomei_kahi.value = taikenuser["syomei_kahi"];
    }*/

    touroku_date.value = taikenuser["touroku_date"];

  }

}else{

  // ログイン画面から、ソーシャルログインを行ってこの画面に飛ばされてきた場合
  if(cookies.isKey('social_login')){
    // cookieにプロバイダー（ソーシャルログインのメディア）が設定されている時は、メッセージを表示。新規登録から入りなおすように誘導する
    if(cookies.isKey('provider')){
      let provider_name = cookies.get('provider')
      if(provider_name == "SignInWithApple"){
        provider_name = "Apple"
      }

      message.value = provider_name+"でアカウント登録はされていません。<br>※新規登録の場合は、「新規登録」画面から入りなおしてください。";
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "social_check";
      contentMessage.value = MessageModal
    }
  }

  // 今日の日付を登録日に代入
  touroku_date.value = year+"-"+('00'+month).slice(-2)+"-"+('00'+day).slice(-2);

}

// 家族登録ありで新規登録時(typeが'toroku'(登録処理)、cookiesの'family' が'yes'(家族登録あり)、multipleprofileがfalse(右メニューからの家族登録はTrueになる))
// 家族の代表者(一般的には、父親か母親)の登録をしてもらうメッセージを出力する
//
// 保護者が必ず必須では無くなりました。体験に参加しない保護者の登録は止めるのでこの文言は必要ない
if(type == 'toroku' && cookies.isKey('family') && cookies.get('family') == 'yes' && multipleprofile == false){
  // kazoku_message.value = '代表者のユーザー情報を登録してください。'
}

// 家族（複数人）登録時は、郵便番号・住所や電話番号(登録対象が未成年だった時の保護者電話番号に使用) 登録時の初期値の設定に使用する。
if(props.param.accountuser != undefined){

    //郵便番号
    if(accountuser["yubin"] != "None"){
      yubin.value = accountuser["yubin"];
    }

    //都道府県コード
    if(accountuser["address_kencd"] != "None" && accountuser["address_kencd"] != "" && accountuser["address_kencd"] != null){
      address_kencd.value = accountuser["address_kencd"];
    }

    //市町村
    if(accountuser["address_shi"] != "None"){
      address_shi.value = accountuser["address_shi"];
    }

    //町域番地以降
    if(accountuser["address_banchi"] != "None"){
      address_banchi.value = accountuser["address_banchi"];
    }

    //保護者名
    if(accountuser["parent_name"] != "None"){
      parent_name.value = accountuser["parent_name"];
    }

    //保護者電話番号
    if(accountuser["hogosyatel"] != "None"){
      hogosyatel.value = accountuser["hogosyatel"];
    }

    //電話番号1
    if(accountuser["usertel1"] != "None"){
      usertel1.value = accountuser["usertel1"];
    }

    //電話番号2
    if(accountuser["usertel2"] != "None"){
      usertel2.value = accountuser["usertel2"];
    }

}

if((mode.value == 'toroku' || mode.value=='kakunin' ) && type == 'henshu'){
  // 登録・確認で編集以外は、チェックボックスでチェックするまで入力禁止にする
  agreed.value = true
}


// 必須項目とエラーメッセージ（切替が発生するのでリアクティブ変数にする）
let schema = ref();

// 表示項目を入れるリスト
let disp_list = [];

// 必須項目を入れるリスト
let schema_list = {};

  // 項目名と変数名のリスト
  let column_list = [["username_sei","氏名（姓）","string"],
                  ["username_mei","氏名（名）","string"],
                  ["username_kana_sei","氏名かな（姓）","hiragana"],
                  ["username_kana_mei","氏名かな（名）","hiragana"],
                  ["usersex","性別","string"],
                  ["userbirth","生年月日","string"],
                  ["yubin","郵便番号","yubin"],
                  ["address_kencd","住所（都道府県）","string"],
                  ["address_shi","住所（市町村）","string"],
                  ["address_banchi","住所（番地以降）","string"],
                  ["usertel1","電話番号","tel"],
                  ["usertel2","電話番号2","tel"],
                  ["hogosyatel","保護者電話番号","number"],
                  ["parent_name","保護者のお名前","string"],
                  ["shokugyo_kbn","体験者区分","string"],
                  ["gakusei_kbn","学生区分","string"],
                  ["gakko_name","学校名","string"],
                  ["gakunen","学年","number"],
                  ["shikaku","趣味・特技・資格","string"],
                  ["katsudou_flg","ボランティア活動経験","string"],
                  ["katsudou_naiyo","ボランティア活動内容","string"],
                  ["smartphone","当日のスマートフォンの使用","string"],
                  ["free_text1",user_free_text1.value,"string"],
                  ["free_text2",user_free_text2.value,"string"],
                  ["free_choice1",user_free_select1.value,"string"],
                  ["free_choice2",user_free_select2.value,"string"]]


  //-------- バリデーション ----------------------------
  let pass_regex = /^(?=.*?[A-Z])(?=.*?\d)(?=.*?[!-\/:-@[-`{-~])[!-~]{8,}$/
  // ひらがな・英数字・記号バリデーション(氏名（かな）用)
  const hiragana = /^[\u3040-\u309f\u0020\u00a0\u3000\u30fb\u30fcＡ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝^a-zA-Z0-9!-/:-@¥[-`{-~]+$/;

  // 項目を確認、設定する
  let column_set = function(){
    disp_list = [];
    schema_list = {};
      
    if(props.param.type == 'henshu'){
      if (document.getElementById("vy_body").clientWidth >= 961) {
        if(userbirth.value != null && userbirth.value != ""){
          
            // 日付データを変数hidukeに格納
            const hiduke = new Date(userbirth.value); 

            // 年・月・日を取得する
            birth_year.value = hiduke.getFullYear();
            birth_month.value = hiduke.getMonth()+1;
            birth_day.value = hiduke.getDate();
        }
      }else{
        // 日付は前ゼロにする。safariのjavascriptでは、前ZEROでないと変換エラーになる。
        userbirth.value = ('0000'+birth_year.value).slice(-4)+"-"+('00'+birth_month.value).slice(-2)+"-"+('00'+birth_day.value).slice(-2)
        
      }
    }

    let j =  0

    for(let f = 0;f<column_list.length;f++){
      // 表示フラグが1の時
      if(disp_flg.value[j] == 1){
        // 名前を格納
        disp_list[column_list[f][0]] = 1

        // 必須フラグが1の時
        if(hissu_flg.value[j] == 1){

          // 体験者区分・学生区分・学年・学校名・活動内容はスルー
          if(column_list[f][0] == "gakusei_kbn" || column_list[f][0] == "shokugyo_kbn" || column_list[f][0] == "gakko_name" ||
             column_list[f][0] == "gakunen" || column_list[f][0] == "katsudou_naiyo"){
              j++
              continue;
          }

          // 保護者名の場合
          if(column_list[f][0] == "parent_name"){
            //pc_age歳以上ならスルー
            if(userbirth.value == '' || getAge(userbirth.value) > (pc_age.value-1)){
              continue;
            }
          }

          // 保護者電話番号の場合
          if(column_list[f][0] == "hogosyatel"){
            //pc_age歳以上ならスルー
            if(userbirth.value == '' || getAge(userbirth.value) > (pc_age.value-1)){
              j++
              continue;
            }
          }

          // デフォルトはテキスト（string）＋必須項目
          let hissu_message = yup.string().required(column_list[f][1] + "は必須項目です。")
          //["username","氏名","string"]
          // 配列から属性を取得
          if(column_list[f][2] == "hiragana"){
            hissu_message = yup.string().matches(hiragana,column_list[f][1]+"はひらがな・英数字・記号のみ入力できます。").required(column_list[f][1]+"は必須項目です。")

          }else if(column_list[f][2] == "yubin"){
            hissu_message = yup.string().min(7,"郵便番号は7桁の数字を入力してください。").max(7,"郵便番号は7桁の数字を入力してください。").required("郵便番号は7桁の数字を入力してください。")
            
          }else if(column_list[f][2] == "number"){
            hissu_message = yup.number().typeError(hiragana,column_list[f][1]+"は数字のみ入力可能です。").required(hiragana,column_list[f][1]+"は必須項目です。")
          }else if(column_list[f][2] == "tel"){
            // 電話番号のチェックは、必須項目チェック、数値チェック、桁数チェック(先頭の3文字が050 060 070 080 090 の時は11桁、それ以外は10桁)
            // transformは、置き換えをしている。vはyupが解釈した値、oは入力値そのままの値  ここでは未入力をundefinedにしている。
            hissu_message = yup.string()
              .transform((v,o) => (o === '' || o == null ? undefined : v))
              .required(column_list[f][1] + "は必須項目です。")
              .matches(/^\d+$/, {
                message: column_list[f][1] + "は数字のみ入力可能です。",
                excludeEmptyString: true,
              })
              .test("phone-length-by-prefix", function (value) {
                if (value == undefined) return true; 
                const prefix3 = value.slice(0, 3);
                const need11 = ["050", "060", "070", "080", "090"].includes(prefix3);
                if (need11 && value.length !== 11) {
                  return this.createError({ message: `${prefix3}から始まる番号は11桁です` });
                }
                if (!need11 && value.length !== 10) {
                  return this.createError({ message: `この番号は10桁で入力してください` });
                }
                return true;
              })
          }

          schema_list[column_list[f][0]] = hissu_message

          
        } else {

        }
      }

      if(column_list[f][0] == "parent_name"){
        //スルー
        continue;
      }

      // 項目名が "username_sei"、"username_kana_sei"以外は、disp_flgとhissu_flgのインデックスをカウントアップする
      if(column_list[f][0] != "username_sei" && column_list[f][0] != "username_kana_sei"){
        j++
      }
  }

  if(props.param.type != 'henshu'){
    disp_list["touroku_date"] = 1
  // schema_list["touroku_date"] = yup.string().required("初回登録年月日は必須項目です。")
  }

  // ユーザーの電話番号1は必ず表示　バリデートの設定をする。
  disp_list["usertel1"] = 1
  /* schema_list["usertel1"] = yup.string()
              .transform((v,o) => (o === '' || o == null ? undefined : v))
              .required("電話番号1は必須項目です。")
              .matches(/^\d+$/, {
                message: "電話番号1は数字のみ入力可能です。",
                excludeEmptyString: true,
              })
              .test("phone-length-by-prefix", function (value) {
                if (value == undefined) return true; 
                const prefix3 = value.slice(0, 3);
                const need11 = ["050", "060", "070", "080", "090"].includes(prefix3);
                if (need11 && value.length !== 11) {
                  return this.createError({ message: `${prefix3}から始まる番号は11桁です` });
                }
                if (!need11 && value.length !== 10) {
                  return this.createError({ message: `この番号は10桁で入力してください` });
                }
                return true;
              })
*/
  // 体験者区分が学生の時は、学校名を必須項目にする  体験区分の初期値は、0(学生)だが念のために確認してます。
  if(shokugyo_kbn.value == '0') {
    if(props.param.type != 'henshu'){
      schema_list["gakusei_kbn"] = yup.string().required("体験者区分が学生の時は、学生区分は必須項目です。")
    }
    schema_list["gakko_name"] = yup.string().required("体験者区分が学生の時は、学校名は必須項目です。")
    schema_list["gakunen"] = yup.string().required("体験者区分が学生の時は、学年は必須項目です。")
  }
  
  // validationを設定
  schema.value = yup.object(schema_list)
}


/* 親コンポーネントに関わる関数 */



// 登録する前に確認
let Update_check = function() {


  if(type=='henshu'){
    // 学生の場合、区分を必ず選んでもらう
    let gakusei_kbn_set = false

    // 学生の場合は学校名、学年が必須
    let gakkoset_flg = false

    // 住所が入力されていればOK
    let jusho_check_flg = false

    // 活動経験によって活動内容の入力有無を確認する
    let katsudou_flg_check = false
    
    // 活動経験が必須項目だった場合
    if('katsudou_flg' in schema_list){

      // 活動経験がある場合
      if(katsudou_flg.value == true){
        // 活動内容が入力されていたらOK
        if(katsudou_naiyo.value != "" && katsudou_naiyo.value != null){
          katsudou_flg_check = true
        }else{
          // 活動内容が未入力ならエラー
          katsudou_flg_check = false
        }
      }else{
        // 活動経験がない場合は問答無用でOK
        katsudou_flg_check = true

      }
    }else{
      // 活動経験が必須じゃない場合は問答無用でOK
      katsudou_flg_check = true
    }

      // 体験者区分が学生の場合
      if(shokugyo_kbn.value == '0'){

        // 学生区分が空欄のままならエラー
        if(gakusei_kbn.value != "--" && gakusei_kbn.value != 7){
          gakusei_kbn_set = true
        }
        // 学校名、学年が両方とも入力されていればOK
        if((gakko_name.value != null && gakko_name.value != '') && (gakunen.value != null && gakunen.value != '' && gakunen.value != '--')){
          gakkoset_flg = true
        }
      }else{
        // 体験者区分が一般の場合はそのままOK
        gakkoset_flg = true
        gakusei_kbn_set = true
      }

    // 有効な住所が入力されていればtrue
    if(address_shi.value != null && address_shi.value != '' && address_shi.value != undefined){
      jusho_check_flg = true
    }

    if(gakusei_kbn_set && gakkoset_flg && jusho_check_flg && katsudou_flg_check){
      
          // 編集の場合、ここで確認モードにして確認用画面を表示する。
          mode.value = "confirm"
          Page_scroll(0)
    }else{

      let set_message = ""
      if(jusho_check_flg == false){
        set_message += "有効な郵便番号を入力してください。\n"
      }
      if(gakusei_kbn_set == false){
        set_message += "学生の方は、必ず学生区分を設定してください。\n";

      }
      if(gakkoset_flg == false){
        set_message += "学生の方は、必ず学校名と学年を入力してください。\n";
      }
      if(katsudou_flg_check == false){
        set_message += "ボランティア活動経験がある方は、活動内容を入力してください。"
      }
          message.value = set_message
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "doui_error";
        contentMessage.value = MessageModal
    }

  }else{
    if ( doui_kiyaku.value != true ) {
          kiyaku_doui_check.value = false
    } else {
          kiyaku_doui_check.value = true
    }
    if ( doui_policy.value != true ) {
          policy_doui_check.value = false
    } else {
          policy_doui_check.value = true
    }
    
    // 活動経験によって活動内容の入力有無を確認する
    let katsudou_flg_check = false
    
    // 活動経験が必須項目だった場合
    if('katsudou_flg' in schema_list){

      // 活動経験がある場合
      if(katsudou_flg.value == true){
        // 活動内容が入力されていたらOK
        if(katsudou_naiyo.value != "" && katsudou_naiyo.value != null){
          katsudou_flg_check = true
        }else{
          // 活動内容が未入力ならエラー
          katsudou_flg_check = false
        }
      }else{
        // 活動経験がない場合は問答無用でOK
        katsudou_flg_check = true

      }
    }else{
      // 活動経験が必須じゃない場合は問答無用でOK
      katsudou_flg_check = true
    }

    // 住所が入力されていればOK
    let jusho_check_flg = false
    
    // 有効な住所が入力されていればtrue
    if(address_shi.value != null && address_shi.value != '' && address_shi.value != undefined){
      jusho_check_flg = true
    }
    // 学生の場合、区分を必ず選んでもらう
    let gakusei_kbn_set = false
    // 学生の場合は学校名、学年が必須
    let gakkoset_flg = false
    let parent_doui_flg = false
      // 体験者区分が学生の場合
      if(shokugyo_kbn.value == '0'){

          // 学生区分が空欄のままならエラー
          if(gakusei_kbn.value != "--" && gakusei_kbn.value != 7){
            gakusei_kbn_set = true
          }
        
          // 学校名と学年が両方とも表示されている場合
          // 学校名、学年が両方とも入力されていればOK
          if((gakko_name.value != null && gakko_name.value != '') && (gakunen.value != null && gakunen.value != '' && gakunen.value != '--')){
            gakkoset_flg = true
          }
      }else{
        // 体験者区分が一般の場合はそのままOK
        gakkoset_flg = true
        gakusei_kbn_set = true
      }


    // pc_age歳未満の場合は親の同意が必須
    if(getAge(userbirth.value) < pc_age.value){
      if(parent_consent.value != "true" && parent_consent.value != true){
        parent_doui_flg = false
      }else{
        if(parent_name.value != "" && parent_name.value != null){
          parent_doui_flg = true
        }else{
          parent_doui_flg = false
        }
      }
    }else{
      parent_doui_flg = true
    }

    if (kiyaku_doui_check.value && policy_doui_check.value && parent_doui_flg && gakkoset_flg && jusho_check_flg && katsudou_flg_check && gakusei_kbn_set) {
        // 新規の場合、重複ユーザーが存在するかチェック
        user_check()
        // message.value = "この内容で登録しますか？";
        // message_cat.value = 1;
        // message_flag.value = true;
        // message_method.value = "update";
        // contentMessage.value = MessageModal
    } else {
      let set_message = ""

      // 変な郵便番号が入力されていればNG
      if(jusho_check_flg == false){
        set_message += "有効な郵便番号を入力してください。\n"
      }

      // 学生の場合は学校名と学年の入力が必要
      if(shokugyo_kbn.value == '0'){
        if(gakusei_kbn_set == false){
          set_message += "学生の方は、必ず学生区分を設定してください。\n";
        }
        
        if(gakkoset_flg == false){
          if('gakko_name' in disp_list && 'gakunen' in disp_list){
            // 学校名と学年が両方とも表示されている場合
            set_message += "学生の方は、必ず学校名と学年を入力してください。\n"
          }else if('gakko_name' in disp_list){
            // 学校名のみ表示されている場合
              set_message += "学生の方は、必ず学校名を入力してください。\n"
          }else if('gakunen' in disp_list){
            // 学年のみ表示されている場合
              set_message += "学生の方は、必ず学年を入力してください。\n"
          }
        }
      }

      // pc_age歳未満の場合は親の同意が必須
      if(getAge(userbirth.value) < pc_age.value){
        if(parent_doui_flg == false){
          set_message += pc_age.value + "歳未満の方は、親の同意と名前が必要です。\n"   
        }
      }

      if(katsudou_flg_check == false){
        set_message += "ボランティア活動経験がある方は、活動内容を入力してください。\n"
        

      }

      // 規約・プライバシーポリシーは必須
      if(!kiyaku_doui_check.value || !policy_doui_check.value){
          set_message += "規約・プライバシーポリシーの同意が必要です。"   
      }

        message.value = set_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "doui_error";
        contentMessage.value = MessageModal

        return
    }
  }
}

// 未入力の必須項目があった場合はメッセージを表示してエラーがあった箇所まで移動する
let InvalidSubmit = function({values, errors, result}){


    if ( doui_kiyaku.value != true ) {
      kiyaku_doui_check.value = false
    } else {
      kiyaku_doui_check.value = true
    }
    if ( doui_policy.value != true ) {
      policy_doui_check.value = false
    } else {
      policy_doui_check.value = true
    }

    if( parent_consent.value != true ){
      parent_doui_check.value = false
    }else{
      parent_doui_check.value = true
    }
    // 必須項目全てのID
    let All_keys = Object.keys(values)
    // 実際にエラーとなっている項目のカラム名を配列で取得し、背景をピンクにする
    let Error_keys = Object.keys(errors)

    let validation_error_id = ""
    let Set_count = 0
    for(let e = 0;e<All_keys.length;e++){
      if(Error_keys.includes(All_keys[e])){
        if(Set_count == 0) validation_error_id = All_keys[e]
        const elements = document.getElementById(All_keys[e])
        elements.style.backgroundColor = "pink"
        Set_count++
      }
    }



  Page_id_focus(validation_error_id)
  message.value = "未入力の必須項目があります。";
  message_cat.value = 0;
  message_flag.value = true;
  message_method.value = "validation_error";
  contentMessage.value = MessageModal
}


// 生年月日を変更した時
let change_birthday = function(birthday){
  
  // pc_age歳未満かつ保護者電話番号が1（必須）の時は必須リストに追加
  if(getAge(birthday) < pc_age.value && hissu_flg.value[10] == 1){
  //schema.value = yup.object(schema_list)
      schema_list["hogosyatel"] = yup.string().required(pc_age.value+"歳未満の場合、保護者電話番号は必須項目です。")
      schema_list["parent_name"] = yup.string().required(pc_age.value+"歳未満の場合、保護者のお名前は必須項目です。")
  }else{
    // pc_age歳以上の場合は必須リストから削除
    delete schema_list["hogosyatel"]
    delete schema_list["parent_name"]
  }
  schema.value = yup.object(schema_list)

}

  // 職業区分の切替
  let change_kbn = function(){

    if(shokugyo_kbn.value == '1'){
      // 一般のvalidationを設定し、学生区分を7（その他）に変更
     // schema.value = schema_standard
      gakusei_kbn.value = 7
    }else{
      // 学生のvalidationを設定
    //  schema.value = schema_gakusei
      gakusei_kbn.value = ''
    }

  }


//------------------ AWS Cognito 関連の処理 ---------------------------
const poolData = {
        UserPoolId: GlobalData.$UserPoolId,  // Your user pool id here
        ClientId: GlobalData.$ClientId  // Your client id here
};
// ユーザープールにアクセスする情報をまとめる
//const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
const userPool = new CognitoUserPool(poolData);

// 属性リスト
let attributeList = [];
let code = ""     //確認コード

// ユーザーのアカウントプロバイダー
let provider = "mail"

//-------- 親コンポーネント（User.vue）によりユーザ情報をＤＢへ登録する
const user_add = () => {
  
    // 郵便番号は必ず７桁の数字を送るようにする
    yubin.value = ("0000000" + yubin.value).slice( -7 ) ;	

    let family = false
    if(taikenuser["family"] != undefined){
        family = taikenuser["family"]
    }
    //  複数ユーザー対応 新規登録時、家族フラグは、アカウントユーザーで家族フラグがtrueの時true
    if(type == 'toroku' && cookies.isKey('family') && cookies.get('family') == 'yes' && multipleprofile == false){
        family = true
    }

    // 更新 or 新規登録する値を連想配列に保存
    let user_data = {
      taikenuser_id:taikenuser_id.value,
      syurui:1,
      subject_id: subject_id,      // CognitoのsubjectID(UUID)
      role: !multipleprofile,       // アカウントの有無(True:ログインユーザー False:家族などのログインできないユーザー)
      family:family,                // 家族の登録がある場合は、true ない場合は、false
      username: [username_sei.value, username_mei.value].filter(Boolean).join("　"),
      username_kana: [username_kana_sei.value, username_kana_mei.value].filter(Boolean).join("　"),
      userbirth: userbirth.value,
      usersex: usersex.value,
      usertel1: usertel1.value,
      usertel2: usertel2.value,
      hogosyatel: hogosyatel.value,
      yubin: yubin.value,
      address_kencd: address_kencd.value,
      address_shi: address_shi.value,
      address_banchi: address_banchi.value,
      shikaku: shikaku.value,
      douki:douki.value,
      katsudou_flg: katsudou_flg.value,
      katsudou_naiyo: katsudou_naiyo.value,
      shokugyo_kbn: shokugyo_kbn.value,
      ippan_kbn: ippan_kbn.value,
      gakusei_kbn: gakusei_kbn.value,
      gakko_name: gakko_name.value,
      gakunen: gakunen.value,
      touroku_date: touroku_date.value,
      parent_consent:parent_consent.value,
      parent_name:parent_name.value,
      smartphone:smartphone.value,
      parent_name:parent_name.value,
      free_text1:free_text1.value,
      free_text2:free_text2.value,
      free_choice1:free_choice1.value,
      free_choice2:free_choice2.value,
      syomei_kahi:syomei_kahi.value,
      sending:sending.value,
      email:GlobalData.$User_email,
      provider:GlobalData.provider,
      update_user: GlobalData.$User_email//更新者（＝ログインユーザーのメールアドレス）
    }


    let cmd = 'user_joho'
    if(type == 'henshu'){
      cmd = "user_koshin"
    }else{
    }

    console.log(cmd)

    // 親コンポーネントへスクロールのリセット
    emit('call',{ cmd:"scroll_position_reset" })
    // 親コンポーネントへ更新 or 新規登録内容を送る
    emit('call',{ cmd:cmd, user_data:user_data, multipleprofile:multipleprofile })

}

//郵便番号から住所を設定する
let search_address_error = 0
let Search_address = function(){ 
  if(yubin.value.trim() == '') return  // 郵便番号が空の場合はなにもしない
  let jsonpAdapter = require('axios-jsonp');
  // 必ず７桁の数字を送るようにする
  //yubin.value = ("0000000" + yubin.value).slice( -7 ) ;	

  axios.get("https://api.zipaddress.net/?zipcode="+yubin.value,
  {
    adapter: jsonpAdapter,
  })
  .then(response => {
    // APIにはcodeが存在し、400 or 404の場合は郵便番号から住所が取得出来ていない場合なので、returnで終了する

    if(response["code"]) {
      if(response["code"] == 400 ||response["code"] == 404){
          return;
      }
    }

    if(GlobalData.$Address_ken_list.indexOf(response.data.pref) <= 0){
      address_kencd.value = ''     // 住所がうまく取得できなかったので、必須入力エラーにするため 空白を設定する
    } else {
      address_kencd.value = GlobalData.$Address_ken_list.indexOf(response.data.pref);// 県名取得→県名からリストの番地を取得→県IDとして保存
    }
    if(response.data.address == undefined || response.data.address.trim() == ''){
      address_shi.value = ''//市町村名
    } else {
      address_shi.value = response.data.address//市町村名
    }

    // changeイベントを発生させて住所(県)入力をしたかのようにしバリデートをする。
    let el = document.getElementById('address_kencd')
    if (el) {el.dispatchEvent(new Event('change', { bubbles: true }))}

    // changeイベントを発生させて住所(市町村)入力をしたかのようにしバリデートをする。
    el = document.getElementById('address_shi')
    if (el) {el.dispatchEvent(new Event('change', { bubbles: true }))}
      
  })
  .catch(error => {
      if(search_address_error == 6){
        alert(error + GlobalData.$axios_error)
      }else{
        search_address_error++
        setTimeout(function(){
          Search_address()
        },"1000")
      }
  })
}

// 誕生日から、年齢を取得する
let getAge = function(birthday){

  //今日
  var today = new Date();
  var set_birthday = birthday.split("-");

  //今年の誕生日
  var thisYearsBirthday = new Date(today.getFullYear(), set_birthday[1]-1, set_birthday[2]);

  //年齢
  var age = today.getFullYear() - set_birthday[0];

  if(today < thisYearsBirthday){
      //今年まだ誕生日が来ていない
      age--;
  }

  return age;

}

// 誕生日から、年齢を取得する
let setAge = function(birthday){

  if(birthday){
    //今日
    var today = new Date();
    var set_birthday = birthday.split("-");

    //今年の誕生日
    var thisYearsBirthday = new Date(today.getFullYear(), set_birthday[1]-1, set_birthday[2]);

    //年齢
    var age = today.getFullYear() - set_birthday[0];

    if(today < thisYearsBirthday){
        //今年まだ誕生日が来ていない
        age--;
    }
    // 生年月日より学生区分(小中高)と学年の設定
    // getSchoolGrade(birthday)

    return age;
  }
}
/*
let getSchoolGrade = function(birthdy){
  // 生年月日より学生区分(小中高)と学年の設定
  // 日本の小・中・高の学年は毎年4月2日から翌年4月1日生まれの人が同級生になるのが基本
  var birthday = birthdy.split("-");

  const birth = new Date(birthday[0],birthday[1]-1,birthday[2]);
  const today = new Date();

  // 今日が属する年度（4/1始まり）  月は、何故か0から始まるので、4月は3になる。
  const fiscalYear =
    today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;

  // その年度の4月1日
  const april1 = new Date(fiscalYear, 3, 1);

  // 4月1日時点の年齢
  let age = april1.getFullYear() - birth.getFullYear();

  // 誕生日が4/2以降なら、4/1時点ではまだ誕生日を迎えていない
  if (birth.getMonth() > 3 || (birth.getMonth() === 3 && birth.getDate() > 1)) { age-- }

  switch (true) {
    case age >= 6 && age <= 11:
      // 小学校
      gakusei_kbn.value = 0
      gakunen.value = age - 5
      break
    case age >= 12 && age <= 14:
      // 中学校
      gakusei_kbn.value = 1
      gakunen.value = age - 11
      break
    case age >= 15 && age <= 17:
      // 高校
      gakusei_kbn.value = 2
      gakunen.value = age - 14
      break
    default:
      // その他
      gakusei_kbn.value = 0
      gakunen.value = "--"
      break  
  }

}
*/
// 指定のタグにフォーカスさせる
let Page_id_focus = function(id){
  if(id=='') return
  const elements = document.getElementById(id)
  elements.focus({preventScroll:false})
    elements.scrollIntoView({ behavior: 'instant', block: 'start' });

}

// 必須項目の背景色を変更する
let Background_change = function(id){
  document.getElementById(id).style.backgroundColor = "white"
}

// ユーザー名を格納する（登録時のみ）
let username_set = function(){
  username.value = "";

  if(username_sei.value != "" && username_mei.value != ""){
    username.value = username_sei.value+username_mei.value
  }
}

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 

  Close_message();//メッセージを表示するウィンドウを閉じる

  if(message_method.value == "user_check"){
    // 重複ユーザーが存在し、そちらでログインする場合、新規登録をやめてログイン画面に移動させる
    logout_move_login()
  }else if(message_method.value == "social_check"){
    // ログイン画面から、ソーシャルログインで新規登録に来てしまった場合は、一度ログアウトして新規登録画面に移動させる
    logout_move_add()
    
  }else{
    // subjectIDを取得する関数を呼び出す。
    get_subid()
  }
}

// 新規登録から、ユーザー情報の存在しないアカウントで入ってしまった場合
let logout_move_add = function(){
  Close_message();//メッセージを表示するウィンドウを閉じる
  emit('call', { cmd:"loading_start" }) // ローディング開始
  emit('call', { cmd:'logout_move_add'}) // 親コンポーネントに「ログアウトして新規登録画面に移動する」命令を送る
}

// メッセージを表示するウィンドウでログアウトを押されたとき
let logout_move_login = function(){
  Close_message();//メッセージを表示するウィンドウを閉じる
  emit('call', { cmd:"loading_start" }) // ローディング開始
  emit('call', { cmd:'logout_move_login'}) // 親コンポーネントに「ログアウトしてログイン画面に移動する」命令を送る
}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
  message_flag.value = false;
  contentMessage.value = null
}

// 趣味・特技・資格テキストエリアの改行
let NewLine_shikaku = function() {
  shikaku.value = `${shikaku.value}\n`;
}

   //年月日の表示を整える
   let DateYearSetting = function(changedate){

    if(changedate != null){
        

        let date = Date.parse(changedate);
        let set_date = new Date(date);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date);

        return set_date.getFullYear()+"年"+(set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")";
    }else{
        return
    }
 }

const moveNext = () => {
  // enter_forcusというクラスの項目内で移動するようにする
  const elements = document.getElementsByClassName('enter_forcus')
  const index = [].findIndex.call(elements, e => e === event.target)

  // 要素数以内であれば次の項目へフォーカス
  if(elements[index + 1]){
    elements[index + 1].focus()
  }
}
const kiyaku = () => { window.open("/Condition","_blank") }
const policy = () => { window.open("/"+cityname+"/Taiken/Policy","_blank")  }

//-------- リンク ---------------
//const home = function() { emit('call', { cmd:'home' }) }
const home = function() { router.push("/"+cityname+"/Taiken/") }
const mypage = function() { router.push("/"+cityname+"/Taiken/mypage") }
const setting = function() { router.push("/"+cityname+"/Taiken/setting") }

// ログアウト移動
const log_out = function() {
  if(multipleprofile){
    // 子登録の場合は単にHOMEに戻す
    home()
  }else{
    // 本人登録の場合はログアウト
    emit('call', { cmd:'logout',id:''})
  }
    
}
emit('call', { cmd:'page_scroll' }) 

/* 変数の監視 */
watchEffect(() => {

  if (document.getElementById("vy_body").clientWidth >= 961) {
    if(userbirth.value != null && userbirth.value != ""){
      
        // 日付データを変数hidukeに格納
        const hiduke = new Date(userbirth.value); 
        
        // 年・月・日を取得する
        birth_year.value = hiduke.getFullYear();
        birth_month.value = hiduke.getMonth()+1;
        birth_day.value = hiduke.getDate();
    }
    
  }else{

    // 日付は前ゼロにする。safariのjavascriptでは、前ZEROでないと変換エラーになる。
    userbirth.value = ('0000'+birth_year.value).slice(-4)+"-"+('00'+birth_month.value).slice(-2)+"-"+('00'+birth_day.value).slice(-2)
    
  }
 
})

// 新規ユーザー登録を締め切っているかどうか
let user_toroku_over = function(){


  return false
}


let manual_open = function(){
    // プロフィール
    let url = "https://zest-newsprint-e3e.notion.site/15ec0be34f8f80bfba28f00cd24817b5#15ec0be34f8f8047a541eb3264e9bba8"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}        

// ？マークをタップしたときのウィンドウ（スマホのみ）
let q_open = function(text){
    message.value = text
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "q_open";
    contentMessage.value = MessageModal

}

let get_subid_error = 0
// Cognitoのsubjectidを取得する。
async function get_subid(){
  provider = GlobalData.provider
  /*
    if(cookies.isKey('provider')){
      provider = cookies.get('provider')
    }

    if(provider == null){
      provider = GlobalData.provider
    }*/

    console.log(provider)
    try {
        const res = await axios.post("/dev/Auth_GetSubjectID", {provider:provider}, { withCredentials: true });
        const sub = res.data; // ← axiosでは .data から取得

        subject_id = sub.subjectid;

        // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
        if(message_method.value == "update"){
          // 登録 or 保存しますか？→OK
          user_add()
        }else if(message_method.value == "validation_error"){
          // 未入力の必須項目があります→OK
          // InvalidSubmitで入力した、未入力の必須項目の中で一番上にあるinput（Field）のID（validation_error_id）を格納する

          /*
          const elements = document.getElementById(validation_error_id);
          // 該当項目へ移動する
          elements.scrollIntoView({ behavior: 'smooth'});
          */
      //   Page_scroll(0)
        }else if(message_method.value == "retry_error"){
          // ログイン状態が確認できない時
          location.href = location.protocol+"//"+location.host+"/"+cityname+"/Taiken/login"
        }

    } catch (err) {
    
        if(get_subid_error == 5){
            console.log("UserToroku get_subid login NO Good"+err);
            
        }else{
            get_subid_error++
            setTimeout(function(){get_subid()},"1000")
        }
    }
}
// ページの一番上にスクロールする：height＝位置（上から何pxか）
const Page_scroll = async (height) => {
  await nextTick()               // Vue の DOM 更新を待つ
  await new Promise(r => setTimeout(r, 0)) // ブラウザのレイアウト確定を待つ

  requestAnimationFrame(() => { // レイアウトが最終確定した次のタイミング
    // スマホ・PCのどちらか、横幅でチェック
    const isSP = window.matchMedia("(max-width: 960px)").matches;
        
    if (isSP) {
      // スマホ
      window.scrollTo({
          top: height,
          left: 0,
          behavior: "auto",
      });
    } else {
      // PC
      const el = document.querySelector("#vy_main")
          
      if (el) {
        el.scrollTo({ top: height, behavior: "auto" })
      }
    }
  })
}


//---------------- ユーザ情報が登録済みか確認する
const user_check = () => {
  let set_user_data = {} 
        // 郵便番号は必ず７桁の数字を送るようにする
        yubin.value = ("0000000" + yubin.value).slice( -7 ) ;	

        let family = false
        if(taikenuser["family"] != undefined){
            family = taikenuser["family"]
        }
        //  複数ユーザー対応 新規登録時、家族フラグは、アカウントユーザーで家族フラグがtrueの時true
        if(type == 'toroku' && cookies.isKey('family') && cookies.get('family') == 'yes' && multipleprofile == false){
            family = true
        }

        // 更新 or 新規登録する値を連想配列に保存
        set_user_data = {
          taikenuser_id:taikenuser_id.value,
          syurui:1,
          subject_id: subject_id,      // CognitoのsubjectID(UUID)
          role: !multipleprofile,       // アカウントの有無(True:ログインユーザー False:家族などのログインできないユーザー)
          family:family,                // 家族の登録がある場合は、true ない場合は、false
          username: [username_sei.value, username_mei.value].filter(Boolean).join("　"),
          username_kana: [username_kana_sei.value, username_kana_mei.value].filter(Boolean).join("　"),
          userbirth: userbirth.value,
          usersex: usersex.value,
          usertel1: usertel1.value,
          usertel2: usertel2.value,
          hogosyatel: hogosyatel.value,
          yubin: yubin.value,
          address_kencd: address_kencd.value,
          address_shi: address_shi.value,
          address_banchi: address_banchi.value,
          shikaku: shikaku.value,
          douki:douki.value,
          katsudou_flg: katsudou_flg.value,
          katsudou_naiyo: katsudou_naiyo.value,
          shokugyo_kbn: shokugyo_kbn.value,
          ippan_kbn: ippan_kbn.value,
          gakusei_kbn: gakusei_kbn.value,
          gakko_name: gakko_name.value,
          gakunen: gakunen.value,
          touroku_date: touroku_date.value,
          parent_consent:parent_consent.value,
          parent_name:parent_name.value,
          smartphone:smartphone.value,
          parent_name:parent_name.value,
          free_text1:free_text1.value,
          free_text2:free_text2.value,
          free_choice1:free_choice1.value,
          free_choice2:free_choice2.value,
          syomei_kahi:syomei_kahi.value,
          sending:sending.value,
          email:GlobalData.$User_email,
          provider:GlobalData.provider,
          update_user: GlobalData.$User_email//更新者（＝ログインユーザーのメールアドレス）
        }

    if(choson_code != ""){
        set_user_data.choson_code = choson_code
    }
    // APIへ値を送信する
    axios.post(url+"TaikenUser_Check",
        set_user_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 2){  // 異常終了時の処理
                alert("ユーザ情報の確認時にエラーが発生しました。")
            }else if(response.data["status"] == 1){  // 重複ユーザー有り
                let check_data = response.data["taikenusers"]
                let check_message = "生年月日、郵便番号、電話番号の同一ユーザーが存在します。\n"

                for(let c = 0;c<check_data.length;c++){

                    check_message += "\n氏名："+check_data[c]["username"]+"</span>" 
                    
                    check_message += "\n登録先："+check_data[c]["shakyo_name"]
                    check_message += "\nアカウント："
                    if(check_data[c]["provider"] == "line"){
                        check_message += "LINE"
                    }else if(check_data[c]["provider"] == "SignInWithApple"){
                        check_message += "Apple"
                    }else if(check_data[c]["provider"] == "Google"){
                        check_message += "Google"
                    }else{
                        check_message += "メールアドレス"
                    }

                }

                message.value = check_message+"\n\n上記の登録ユーザーでログインしなおしますか？\n※OKを押すとログイン画面に移動しますので、そちらでログインしなおしてください。";
                message_cat.value = 1;
                message_flag.value = true;
                message_method.value = "user_check";
                contentMessage.value = MessageModal
            }else{ 
              // 重複ユーザーなしの場合、ここで確認モードにして確認用画面を表示する。
              mode.value = "confirm"
              Page_scroll(0)
            }
        })
        .catch(error => {
            alert("ユーザ情報の登録時にエラーが発生しました。"+error)
            
        })
}


// ダブルクリック抑制
let toroku_count = 0
let TorokuProc = function(){
  if(toroku_count == 0){
    toroku_count += 1
    message_method.value = "update"
    // subjectIDを取得する関数を呼び出す。
    console.log("toroku_count"+toroku_count)
    get_subid()
  }

}
let ReturnProc = function(){
  mode.value = "toroku"
  Page_scroll(0)
}

//---------------- 社協英名から社協ごとの設定を取得
let shakyo_read_error = 0
let shakyo_read = function(){
    axios.post(url+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {
        Shakyo_data =  response["data"]
        user_add_message.value = Shakyo_data['user_add_message']
        pc_age.value = Shakyo_data['pc_age']
        choson_code = response["data"].choson_code
            // ユーザー登録終了日時の確認
            let today = new Date()
            // ユーザー登録終了日時を利用する場合（未入力の場合はスルー）
            if(Shakyo_data.user_end_date){
                let end_date = Kokai_setting(Shakyo_data.user_end_date,Shakyo_data.user_end_time)

                console.log(today)
                console.log(end_date)

                // 終了日時が今日より前なら、登録を不可とする
                if (end_date <= today) {
                  console.log(mode.value)
                  if(type == 'toroku'){
                      mode.value = 'end';
                  }
                }
            }

      })
    .catch(error => {
        
        if(shakyo_read_error == 6){
            alert("社協の設定情報取得に失敗しました。"+error);
        }else{
            shakyo_read_error++
            setTimeout(function(){shakyo_read()},"1000")
        }
    })
}

// 社協の設定項目の読み込み
shakyo_read()

// 画面がリサイズされた時にＰＣかスマホかの判断をする
const handleResize = () => {
  isSP.value = window.matchMedia("(max-width: 960px)").matches
}

// autokanaの初期設定
const init_username_sei_kana = async () => {
  if (autokana_sei) return  // 項目同士の紐付けが既に出来ていたら抜ける。

  await nextTick()  // DOM描画完了を待つ
  await new Promise(r => setTimeout(r, 0)) // ブラウザのレイアウト確定を待つ

    requestAnimationFrame(() => { // レイアウトが最終確定した次のタイミング(氏名(姓)と氏名かな（姓）項目を作成後)
      // かな自動入力 カタカナ:false ひらがなにする
      // 氏名(姓)と氏名かな（姓）を紐付ける
      autokana_sei = AutoKana.bind('#username_sei', '#username_kana_sei', {
        katakana: false
      })
    }
  )
}

// autokanaの初期設定
const init_username_mei_kana = async () => {
  if (autokana_mei) return  // 項目同士の紐付けが既に出来ていたら抜ける。

  await nextTick()  // DOM描画完了を待つ
  await new Promise(r => setTimeout(r, 0)) // ブラウザのレイアウト確定を待つ

    requestAnimationFrame(() => { // レイアウトが最終確定した次のタイミング(氏名(名)と氏名かな（名）項目を作成後)
      // かな自動入力 カタカナ:false ひらがなにする
      // 氏名(名)と氏名かな（名）を紐付ける
      autokana_mei = AutoKana.bind('#username_mei', '#username_kana_mei', {
        katakana: false
      })
    }
  )
}
// かなの整形  カタカナが来た場合にひらがなへ ひらがな以外は除去等
const normalizeHiragana = (text) => {
  return (text || '')
    .replace(/[ァ-ヶ]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0x60))
    .replace(/[^\u3041-\u3096ー\s　]/g, '')
    .replace(/[ 　]+/g, ' ')
    .trim()
}
// 氏名(姓)に入力した時に自動で氏名かな(姓)にひらがなを入れる
const username_sei_kana = async () => {
  if (!autokana_sei) {
    // 氏名(姓)と氏名かな(姓)の紐付け情報が作成されていない時は、作成する。 
    await init_username_sei_kana()
  }
  // setFieldValue('username_kana_sei', normalizeHiragana(autokana_sei.getFurigana()))
  if(autokana_sei == null) return
  if(username_sei.value != '' && normalizeHiragana(autokana_sei.getFurigana()) == '') return

  username_kana_sei.value = normalizeHiragana(autokana_sei.getFurigana())
  if(normalizeHiragana(autokana_sei.getFurigana()) != ''){
    // changeイベントを発生させてかな入力をしたかのようにしバリデートをする。
    const el = document.getElementById('username_kana_sei')
    if (el) {el.dispatchEvent(new Event('change', { bubbles: true }))}
  }
}

// 氏名(名)に入力した時に自動で氏名かな(名)にひらがなを入れる
const username_mei_kana = async () => {
  if (!autokana_mei) {
    // 氏名(名)と氏名かな(名)の紐付け情報が作成されていない時は、作成する。 
    await init_username_mei_kana()
  }
  // setFieldValue('username_kana_mei', normalizeHiragana(autokana_mei.getFurigana()))
  if(autokana_mei == null) return
  if(username_mei.value != '' && normalizeHiragana(autokana_mei.getFurigana()) == '') return

  username_kana_mei.value = normalizeHiragana(autokana_mei.getFurigana())
  if(normalizeHiragana(autokana_mei.getFurigana()) != ''){
    // changeイベントを発生させてかな入力をしたかのようにしバリデートをする。
    const el = document.getElementById('username_kana_mei')
    if (el) {el.dispatchEvent(new Event('change', { bubbles: true }))}
  }
}

// 氏名(姓)と氏名(名)の表示項目が作成された時  agreedは、登録時の注意事項を確認したかどうかのチェックボックス
watch(agreed, (newVal, oldVal) => {
  if(newVal == false) {
    autokana_sei = null
    autokana_mei = null
    return
  }

  init_username_sei_kana()
  init_username_mei_kana()

});

// 体験者区分が学生の時は、学校名を必須項目にする
watch(shokugyo_kbn, (newVal, oldVal) =>{
  if(agreed.value == false) return
  if(newVal == '0') {
    if(props.param.type != 'henshu'){
      schema_list["gakusei_kbn"] = yup.string().required("体験者区分が学生の時は、学生区分は必須項目です。")
    }
    schema_list["gakko_name"] = yup.string().required("体験者区分が学生の時は、学校名は必須項目です。")
    schema_list["gakunen"] = yup.string().required("体験者区分が学生の時は、学年は必須項目です。")
  } else {
    if(props.param.type != 'henshu'){
      delete schema_list['gakusei_kbn']
    }
    delete schema_list['gakko_name']
    delete schema_list['gakunen']
  }
  // validationを設定
  schema.value = yup.object(schema_list)

});

onMounted(() => {
  // リサイズ監視イベント開始
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  // リサイズ監視のイベントを破棄する(メモリーリーク対応)
  window.removeEventListener('resize', handleResize)
})

/* 初期処理 */
// 職業区分によってschemaの中身を変える
change_kbn()

// 表示・必須項目を設定する
column_set()


emit('call', { cmd:'loading_end_noreload'})
</script>

<style scoped>
table, td {border:none; text-align:left }
p { text-align:left }
button { border: 1px solid #000;width:300px;height:50px;background:#eee;text-align:left }
.boff { border:none;resize:none }
.error{
  color: red;
}
.form-group{
  width:100%
}

.form-check{
  margin-left:0;
  padding-left: 0;
}

input[type=radio],input[type=checkbox]{
  width: 20px;
  height: 20px;
  margin:2px 10px 0 0;
}

@media screen and (min-width: 961px) {

  /* PC版 */
  .floating_over{
      display: none
  }
}


@media screen and (max-width: 960px) {
  /* スマホ版 */
  .floating_over{
            display: flex
        }
}

/* 念のため：万一ツールバーDOMが出ても非表示 */
:deep(.ql-toolbar) { display: none !important; }
/* 表示専用っぽく枠を消したい場合 */
:deep(.ql-container) { border: none !important; }

</style>
